/* CHELL-OH! theme script. Built by shopify/build_theme.py from the mockup parts and shopify/src/js. */
    /* the Juggler (Tess's drawing): a three-lemon shower. Each lemon leaves the left hand, rides the big arc over his head
       exactly where the drawing puts them, drops into the right hand and is passed back low to the left. Twin motion
       lines trail each lemon like the ones in the drawing. With reduced motion the drawing stays as supplied. */
    (function(){
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var svgs = Array.prototype.slice.call(document.querySelectorAll('.juggler'));
      if (reduce) { window.CHJuggler = { add: function(){} }; return; }
      var NS = 'http://www.w3.org/2000/svg';
      var C = { x: 12.29, y: 13.06 }, TH0 = 155.2, TH1 = 403.7;          /* the circle through the three drawn lemons */
      var L0 = { x: 2.9, y: 17.4 }, R0 = { x: 20.6, y: 21.0 };             /* a lemon sitting in each palm */
      var PERIOD = 2.4, ARC = 0.86;                                         /* seconds per lap; share of the lap spent in the air */
      function rad(d){ return d * Math.PI / 180; }
      function radiusAt(th){                                                /* on the circle, easing into each palm */
        var a = Math.max(0, 1 - (th - TH0) / 40), b = Math.max(0, (th - (TH1 - 50)) / 50);
        return 10.47 + (10.34 - 10.47) * a * a + (11.49 - 10.47) * b * b;
      }
      function onArc(th, dr){ var r = radiusAt(th) + (dr || 0); return { x: C.x + r * Math.cos(rad(th)), y: C.y + r * Math.sin(rad(th)) }; }
      /* gravity: quick off the hand, slow over the top, quick into the other hand */
      function flight(u){ return u + 0.4 * Math.sin(2 * Math.PI * u) / (2 * Math.PI); }
      function trail(th0, th1, dr){
        var d = '', n = 7;
        for (var i = 0; i <= n; i++) { var p = onArc(th0 + (th1 - th0) * i / n, dr); d += (i ? 'L' : 'M') + p.x.toFixed(2) + ' ' + p.y.toFixed(2); }
        return d;
      }
      var io = 'IntersectionObserver' in window ? new IntersectionObserver(function(entries){ entries.forEach(function(en){ sets.forEach(function(s){ if (s.svg === en.target) s.visible = en.isIntersecting; }); }); }, { threshold: 0 }) : null;
      var sets = [];
      function add(svg){
        if (reduce || svg.classList.contains('is-live')) return;
        svg.classList.add('is-live');
        var tg = svg.querySelector('.trails');
        var balls = Array.prototype.slice.call(svg.querySelectorAll('.ball')).map(function(g, k){
          var a = document.createElementNS(NS, 'path'), b = document.createElementNS(NS, 'path');
          if (tg) { tg.appendChild(a); tg.appendChild(b); }
          return { g: g, cx: parseFloat(g.getAttribute('data-cx')), cy: parseFloat(g.getAttribute('data-cy')), k: k, ta: a, tb: b, spin: k === 1 ? -1 : 1 };
        });
        sets.push({ svg: svg, balls: balls, visible: true, t0: performance.now() });
        if (io) io.observe(svg);
      }
      /* pages that draw a Juggler later (the product pages) hand it over here */
      window.CHJuggler = { add: add };
      svgs.forEach(add);
      /* evenly spaced, a third of a lap apart, starting where the drawing is: left, top and right of the arc */
      var START = [0.053, 0.386, 0.719];
      function place(s, now){
        var t = (now - s.t0) / 1000;
        s.balls.forEach(function(b){
          var ph = ((t / PERIOD + START[b.k % 3]) % 1 + 1) % 1, x, y, rot, op = 0, th;
          if (ph < ARC) {
            var u = ph / ARC, f = flight(u);
            th = TH0 + (TH1 - TH0) * f;
            var p = onArc(th); x = p.x; y = p.y;
            rot = b.spin * (f * 200 - 40);
            op = Math.min(1, u / 0.12, (1 - u) / 0.14);
          } else {
            var v = (ph - ARC) / (1 - ARC), e = 0.5 - 0.5 * Math.cos(Math.PI * v);
            /* the low pass, right palm to left palm, dipping past the belt */
            var mx = 11.6, my = 26.2;
            x = (1 - e) * (1 - e) * R0.x + 2 * (1 - e) * e * mx + e * e * L0.x;
            y = (1 - e) * (1 - e) * R0.y + 2 * (1 - e) * e * my + e * e * L0.y;
            rot = b.spin * (160 + 40 * e) - b.spin * 200 * e;
          }
          b.g.setAttribute('transform', 'translate(' + (x - b.cx).toFixed(3) + ' ' + (y - b.cy).toFixed(3) + ') rotate(' + rot.toFixed(1) + ' ' + b.cx.toFixed(3) + ' ' + b.cy.toFixed(3) + ')');
          if (op > 0.02) {
            var gap = 17, len = 17;
            b.ta.setAttribute('d', trail(th - gap - len, th - gap, 0.5)); b.tb.setAttribute('d', trail(th - gap - len * 0.8, th - gap - len * 0.05, -0.5));
            b.ta.style.opacity = op.toFixed(2); b.tb.style.opacity = op.toFixed(2);
          } else { b.ta.setAttribute('d', ''); b.tb.setAttribute('d', ''); }
        });
      }
      function tick(now){ sets = sets.filter(function(s){ return s.svg.isConnected; }); sets.forEach(function(s){ if (s.visible) place(s, now); }); requestAnimationFrame(tick); }
      requestAnimationFrame(tick);
    })();

  /* =================== shared: mega menus, mobile menu, cart =================== */
  (function(){
    var nav = document.querySelector('header.nav'), scrim = document.getElementById('mega-scrim');
    if (!nav || !scrim) return;
    var trigs = Array.prototype.slice.call(document.querySelectorAll('.mtrig'));
    var panels = {}; trigs.forEach(function(t){ panels[t.getAttribute('data-mega')] = document.getElementById('mega-' + t.getAttribute('data-mega')); });
    var menuBtn = document.getElementById('menu-btn'), menu = document.getElementById('mobile-menu');
    var openKey = null, closeT = null, fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var morph = document.getElementById('morph');
    function setOn(){
      var on = !!openKey || (menu && !menu.hidden); nav.classList.toggle('mega-on', on); document.body.classList.toggle('mega-open', on); scrim.hidden = !on;
      /* homepage: keep the logo tab above an open menu once it has docked in the nav, but not while it is the big hero logo */
      if (morph) { var na = document.getElementById('navanchor'); morph.classList.toggle('raise', on && !!na && morph.getBoundingClientRect().height <= na.getBoundingClientRect().height * 1.2); }
    }
    function openMega(k){
      clearTimeout(closeT);
      if (openKey === k) return;
      Object.keys(panels).forEach(function(n){ panels[n].hidden = n !== k; });
      trigs.forEach(function(t){ t.setAttribute('aria-expanded', String(t.getAttribute('data-mega') === k)); });
      openKey = k; setOn();
    }
    function closeMega(){ Object.keys(panels).forEach(function(n){ panels[n].hidden = true; }); trigs.forEach(function(t){ t.setAttribute('aria-expanded', 'false'); }); openKey = null; setOn(); }
    function later(){ clearTimeout(closeT); closeT = setTimeout(closeMega, 220); }
    trigs.forEach(function(t){
      var k = t.getAttribute('data-mega');
      t.addEventListener('click', function(e){ if (t.tagName === 'A' && (fine || openKey === k)) return; e.preventDefault(); if (openKey === k) closeMega(); else openMega(k); });
      if (fine) { t.addEventListener('mouseenter', function(){ openMega(k); }); t.addEventListener('mouseleave', later); }
    });
    Object.keys(panels).forEach(function(k){
      var p = panels[k];
      if (fine) { p.addEventListener('mouseenter', function(){ clearTimeout(closeT); }); p.addEventListener('mouseleave', later); }
      p.addEventListener('click', function(e){ if (e.target.closest('a')) closeMega(); });
    });
    function closeMenu(){ if (!menu) return; menu.hidden = true; menuBtn.setAttribute('aria-expanded', 'false'); menuBtn.textContent = 'Menu'; setOn(); }
    if (menuBtn && menu) {
      menuBtn.addEventListener('click', function(){ var open = menu.hidden; menu.hidden = !open; menuBtn.setAttribute('aria-expanded', String(open)); menuBtn.textContent = open ? 'Close' : 'Menu'; setOn(); });
      menu.addEventListener('click', function(e){ if (e.target.closest('a')) closeMenu(); });
    }
    scrim.addEventListener('click', function(){ closeMega(); closeMenu(); });
    document.addEventListener('keydown', function(e){ if (e.key === 'Escape') { closeMega(); closeMenu(); } });
    window.CHNav = { close: function(){ closeMega(); closeMenu(); } };
  })();


  /* =================== speech bubbles: inked by hand like the kangaroos =================== */
  /* Each bubble is drawn at its real size as a filled ink line: the weight swells and thins, the line wobbles, it starts and ends
     with a taper and overshoots where the pen comes back round, with a second quick pass on one corner. Redrawn whenever the
     bubble changes size (and when a hidden page first shows it). The tail sits bottom left; CSS mirrors it where needed. */
  (function(){
    var NS = 'http://www.w3.org/2000/svg';
    function rng(seed){ return function(){ seed = (seed * 16807) % 2147483647; return (seed - 1) / 2147483646; }; }
    function outline(W, H, R){
      var th = Math.max(20, Math.min(30, H * 0.2)), L = 4, T = 4, Rt = W - 4, B = H - th - 3;
      var r = Math.min(64, (B - T) * 0.48), rc = [r * (0.9 + R() * 0.25), r * (0.85 + R() * 0.3), r * (0.9 + R() * 0.25), r * (0.85 + R() * 0.3)];
      var tx0 = L + rc[3] + 10, tx1 = tx0 + Math.min(30, W * 0.08), tip = { x: tx0 - 14, y: H - 3 };
      var pts = [], step = 3;
      function line(ax, ay, bx, by){ var d = Math.hypot(bx - ax, by - ay), n = Math.max(1, Math.round(d / step)); for (var i = 0; i < n; i++) pts.push({ x: ax + (bx - ax) * i / n, y: ay + (by - ay) * i / n }); }
      function arc(cx, cy, rr, a0, a1){ var n = Math.max(2, Math.round(Math.abs(a1 - a0) * rr / step)); for (var i = 0; i < n; i++) { var a = a0 + (a1 - a0) * i / n; pts.push({ x: cx + rr * Math.cos(a), y: cy + rr * Math.sin(a) }); } }
      var start = L + rc[0] + 26, P = Math.PI;
      line(start, T, Rt - rc[1], T);                    // top
      arc(Rt - rc[1], T + rc[1], rc[1], -P / 2, 0);        // top right
      line(Rt, T + rc[1], Rt, B - rc[2]);                // right
      arc(Rt - rc[2], B - rc[2], rc[2], 0, P / 2);         // bottom right
      line(Rt - rc[2], B, tx1, B);                       // bottom, to the tail
      var tipAt = pts.length;
      line(tx1, B, tip.x, tip.y); tipAt = pts.length; line(tip.x, tip.y, tx0, B);   // the tail
      line(tx0, B, L + rc[3], B);                        // bottom, past the tail
      arc(L + rc[3], B - rc[3], rc[3], P / 2, P);          // bottom left
      line(L, B - rc[3], L, T + rc[0]);                  // left
      arc(L + rc[0], T + rc[0], rc[0], P, 1.5 * P);        // top left
      line(L + rc[0], T, start + 38, T);                 // round again, past where it started
      return { pts: pts, tipAt: tipAt };
    }
    function ink(pts, base, R, opts){
      opts = opts || {};
      var n = pts.length, s = 0, f = [R() * 6, R() * 6, R() * 6, R() * 6, R() * 6], len = [0], i;
      for (i = 1; i < n; i++) { s += Math.hypot(pts[i].x - pts[i - 1].x, pts[i].y - pts[i - 1].y); len.push(s); }
      var total = s, A = [], Bp = [];
      for (i = 0; i < n; i++) {
        var a = pts[Math.max(0, i - 2)], b = pts[Math.min(n - 1, i + 2)], tx = b.x - a.x, ty = b.y - a.y, tl = Math.hypot(tx, ty) || 1;
        var nx = -ty / tl, ny = tx / tl, d = len[i];
        var wob = 2.2 * Math.sin(d / 97 + f[0]) + 0.9 * Math.sin(d / 31 + f[1]) + 0.35 * Math.sin(d / 9 + f[4]) + (opts.lift && d > total - 44 ? -1.9 : 0);
        var w = base * (0.78 + 0.3 * Math.sin(d / 47 + f[2]) + 0.18 * Math.sin(d / 13 + f[3]) + 0.1 * Math.sin(d / 5 + f[4]));
        w *= Math.min(1, 0.2 + d / 22) * Math.min(1, 0.12 + (total - d) / 28);
        if (opts.tipAt && Math.abs(i - opts.tipAt) < 5) w *= 0.45 + Math.abs(i - opts.tipAt) * 0.11;
        w = Math.max(0.35, w);
        var x = pts[i].x + nx * wob, y = pts[i].y + ny * wob;
        A.push((x + nx * w / 2).toFixed(1) + ' ' + (y + ny * w / 2).toFixed(1));
        Bp.push((x - nx * w / 2).toFixed(1) + ' ' + (y - ny * w / 2).toFixed(1));
      }
      return 'M' + A.join('L') + 'L' + Bp.reverse().join('L') + 'Z';
    }
    var k = 0;
    function draw(b){
      var svg = b.querySelector('.bline'); if (!svg) return;
      var W = b.offsetWidth, H = b.offsetHeight; if (W < 40 || H < 40) return;
      if (b._ink && b._ink.w === W && b._ink.h === H) return;
      if (!b._seed) b._seed = 1234 + (++k) * 7919;
      var R = rng(b._seed), o = outline(W, H, R), base = W < 420 ? 2.6 : 3.1;
      var d = ink(o.pts, base, R, { tipAt: o.tipAt, lift: true });
      /* a second, lighter pass on the top right corner, the way a pen goes back over a line */
      var from = Math.round(o.pts.length * (0.18 + R() * 0.06)), seg = o.pts.slice(from, from + 22).map(function(p){ return { x: p.x - 2.2, y: p.y + 2.2 }; });
      d += ink(seg, base * 0.55, R);
      svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H); svg.removeAttribute('preserveAspectRatio');
      var path = svg.querySelector('path') || svg.appendChild(document.createElementNS(NS, 'path'));
      path.setAttribute('d', d); svg.classList.add('inked');
      b._ink = { w: W, h: H };
    }
    var bubbles = Array.prototype.slice.call(document.querySelectorAll('.bubble'));
    if ('ResizeObserver' in window) { var ro = new ResizeObserver(function(en){ en.forEach(function(e){ draw(e.target); }); }); bubbles.forEach(function(b){ ro.observe(b); }); }
    else { bubbles.forEach(draw); window.addEventListener('resize', function(){ bubbles.forEach(draw); }); }
    window.CHBubble = function(scope){ Array.prototype.forEach.call((scope || document).querySelectorAll('.bubble'), function(b){ if (b._obs) return; b._obs = 1; if (typeof ro !== 'undefined' && ro) ro.observe(b); else draw(b); }); };
    bubbles.forEach(function(b){ b._obs = 1; });
  })();

  /* =================== theme core: smooth scroll, page colour, reveals, About chapters, cards, age check =================== */
  (function(){
    var CH = window.CH = window.CH || {};
    var M = CH.motion || {};
    var body = document.body, root = document.documentElement;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var animOn = M.reveals !== false && !reduce;
    var qa = function(r, s){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    CH.qa = qa; CH.reduce = reduce; CH.design = design;

    /* ---- never split the brand name across two lines (the hyphen is a break point) ---- */
    (function(){
      var re = /CHELL-OH!?/i, skip = /^(SCRIPT|STYLE|TEXTAREA|INPUT|SELECT|OPTION|NOSCRIPT|SVG|TITLE)$/;
      var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, { acceptNode: function(n){
        if (!re.test(n.nodeValue)) return NodeFilter.FILTER_REJECT;
        for (var p = n.parentNode; p && p !== document.body; p = p.parentNode) { if (skip.test(p.nodeName.toUpperCase()) || (p.classList && p.classList.contains('nobr'))) return NodeFilter.FILTER_REJECT; }
        return NodeFilter.FILTER_ACCEPT;
      } }), list = [];
      while (w.nextNode()) list.push(w.currentNode);
      list.forEach(function(n){
        var f = document.createDocumentFragment(), parts = n.nodeValue.split(/(CHELL-OH!?)/i);
        parts.forEach(function(s, i){ if (!s) return; if (i % 2) { var sp = document.createElement('span'); sp.className = 'nobr'; sp.textContent = s; f.appendChild(sp); } else f.appendChild(document.createTextNode(s)); });
        /* in a flex or grid box (accordion summaries, buttons), keep the line as one item so the layout doesn't split it apart */
        var par = n.parentNode, d = par.nodeType === 1 ? getComputedStyle(par).display : '';
        if (/flex|grid/.test(d)) { var wrap = document.createElement('span'); wrap.appendChild(f); f = wrap; }
        par.replaceChild(f, n);
      });
    })();

    /* ---- recipe grids: Melon cards (purple photos) never sit next to or straight above each other, at any column count.
       Keeps the original order within Lemon and within Melon; if there's no way to keep them apart, the order is left alone. ---- */
    (function(){
      var grids = qa(document, '.rgrid'); if (!grids.length) return;
      function cols(g){ var t = getComputedStyle(g).gridTemplateColumns; return t && t !== 'none' ? t.trim().split(/\s+/).length : 1; }
      function arrange(g){
        if (!g._orig) g._orig = Array.prototype.filter.call(g.children, function(c){ return c.hasAttribute('data-p'); });
        var orig = g._orig, n = orig.length; if (n < 3) return;
        var C = cols(g); if (g._c === C) return; g._c = C;
        var mel = orig.map(function(c){ return c.getAttribute('data-p') === 'melon'; }), out = [], used = [];
        function ok(i, pos){ if (!mel[i]) return true; var l = pos % C ? out[pos - 1] : -1, u = pos >= C ? out[pos - C] : -1; return !(l >= 0 && mel[l]) && !(u >= 0 && mel[u]); }
        function dfs(pos){
          if (pos === n) return true;
          var tried = {};
          for (var i = 0; i < n; i++) {
            if (used[i] || tried[mel[i]]) continue; tried[mel[i]] = 1;   /* next unused Lemon or next unused Melon */
            if (!ok(i, pos)) continue;
            used[i] = true; out[pos] = i; if (dfs(pos + 1)) return true; used[i] = false;
          }
          return false;
        }
        var order = dfs(0) ? out.slice(0, n) : orig.map(function(_, i){ return i; });
        order.forEach(function(i){ g.appendChild(orig[i]); });
      }
      function all(){ grids.forEach(arrange); }
      all();
      var rt = null; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(all, 150); });
    })();

    /* ---- smooth scroll (Theme settings > Motion). Off in the editor and for people who asked for less motion ---- */
    var lenis = null, listeners = [];
    CH.onScroll = function(fn){ listeners.push(fn); };
    function fire(){ for (var i = 0; i < listeners.length; i++) listeners[i](); }
    function startLenis(){
      if (!M.smooth || reduce || design || !window.Lenis || lenis) return;
      try { lenis = new Lenis({ lerp: 0.09, smoothWheel: true }); lenis.on('scroll', fire); (function raf(t){ if (!lenis) return; lenis.raf(t); requestAnimationFrame(raf); })(0); } catch (e) { lenis = null; }
    }
    window.addEventListener('scroll', function(){ if (!lenis) requestAnimationFrame(fire); }, { passive: true });
    CH.scrollTo = function(el, offset){
      if (!el) return;
      if (lenis) lenis.scrollTo(el, { offset: offset || 0, duration: 1.4 });
      else window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY + (offset || 0), behavior: reduce ? 'auto' : 'smooth' });
    };
    CH.lenis = function(){ return lenis; };

    /* ---- in-page links (#reviews, #enquire, #h-shop) scroll smoothly; the sticky header is allowed for ---- */
    document.addEventListener('click', function(e){
      var a = e.target.closest('a[href*="#"], [data-scroll]'); if (!a) return;
      var id;
      if (a.hasAttribute('data-scroll')) id = a.getAttribute('data-scroll');
      else {
        var href = a.getAttribute('href'), i = href.indexOf('#'); if (i < 0) return;
        var path = href.slice(0, i); if (path && path !== location.pathname && path !== location.href.split('#')[0]) return;
        id = decodeURIComponent(href.slice(i + 1));
      }
      if (!id) return;
      var t = document.getElementById(id); if (!t) return;
      e.preventDefault();
      var head = document.querySelector('.section-header'), off = head && !root.classList.contains('has-morph') ? -head.offsetHeight : 0;
      CH.scrollTo(t, off);
      if (history.replaceState) history.replaceState(null, '', '#' + id);
    });

    /* ---- page colour: the page takes the colour of whatever section is in the reading band ---- */
    var tio = null;
    CH.themeTargets = function(){ return qa(document, 'main [data-theme], footer[data-theme]'); };
    function watchColour(){
      if (tio) tio.disconnect();
      var list = CH.themeTargets();
      if (list[0]) body.setAttribute('data-theme', list[0].getAttribute('data-theme'));
      if (M.colour === 'blocks' || !('IntersectionObserver' in window)) return;
      tio = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if (!en.isIntersecting) return;
          body.setAttribute('data-theme', en.target.getAttribute('data-theme'));
          if (en.target.hasAttribute('data-i') && CH.showcaseStep) CH.showcaseStep(en.target);
        });
      }, { rootMargin: '-32% 0px -68% 0px', threshold: 0 });
      list.forEach(function(el){ if (el.offsetParent !== null || el.getClientRects().length) tio.observe(el); });
    }
    CH.watchColour = watchColour;

    /* ---- headings rise in word by word; blocks fade up ---- */
    var rio = null;
    function reveals(scope){
      if (!animOn || design || !('IntersectionObserver' in window)) { qa(scope, '.is-hidden').forEach(function(el){ el.classList.remove('is-hidden'); }); return; }
      if (!rio) rio = new IntersectionObserver(function(entries){ entries.forEach(function(en){ if (en.isIntersecting) { en.target.classList.remove('is-hidden'); rio.unobserve(en.target); } }); }, { threshold: 0.12 });
      qa(scope, '.reveal:not([data-split])').forEach(function(el){
        el.setAttribute('data-split', '1');
        el.innerHTML = el.textContent.trim().split(/[ \t\n\r]+/).map(function(w, i){ return '<span class="w"><span style="--i:' + i + '">' + w.replace(/[<>&]/g, function(c){ return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; }) + '</span></span>'; }).join(' ');
      });
      qa(scope, '.reveal, .fade').forEach(function(el){
        if (el.closest('.hs .stage')) return;
        var r = el.getBoundingClientRect();
        if (r.top > window.innerHeight * 0.92) { el.classList.add('is-hidden'); rio.observe(el); } else el.classList.remove('is-hidden');
      });
    }

    /* ---- a paragraph that lights up line by line as it's read (the homepage story) ---- */
    var litParas = [];
    function litSetup(scope){
      qa(scope, '[data-fade-in]').forEach(function(p){ p.classList.add('fade'); });
      if (reduce || design) return;
      qa(scope, '[data-lit-lines]:not([data-lit-done])').forEach(function(p){
        p.setAttribute('data-lit-done', '1');
        p.innerHTML = p.textContent.trim().split(/[ \t\n\r]+/).map(function(w){ return '<span class="w">' + w.replace(/[<>&]/g, function(c){ return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; }) + '</span>'; }).join(' ');
        var o = { el: p, ws: qa(p, '.w'), lines: [] }; litParas.push(o); litLayout(o);
      });
    }
    function litLayout(o){
      var map = {}; o.ws.forEach(function(w){ var t = w.offsetTop; (map[t] = map[t] || []).push(w); });
      o.lines = Object.keys(map).map(Number).sort(function(a, b){ return a - b; }).map(function(t){ return { top: t, ws: map[t], v: -1 }; });
    }
    function litUpdate(){
      var vh = window.innerHeight;
      litParas = litParas.filter(function(o){ return o.el.isConnected; });
      litParas.forEach(function(o){
        var pr = o.el.getBoundingClientRect(); if (pr.bottom < -vh || pr.top > vh * 2) return;
        o.lines.forEach(function(L){
          var v = Math.round(Math.min(1, Math.max(0, (vh * 0.88 - (pr.top + L.top)) / (vh * 0.24))) * 40) / 40;
          if (v !== L.v) { L.v = v; var op = (0.18 + 0.82 * v).toFixed(3); L.ws.forEach(function(w){ w.style.opacity = op; }); }
        });
      });
    }
    CH.onScroll(litUpdate);
    window.addEventListener('resize', function(){ litParas.forEach(litLayout); litUpdate(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ litParas.forEach(litLayout); litUpdate(); });

    /* ---- About: a chapter's pictures arrive as it reaches the middle of the screen ---- */
    var chio = null;
    function chapters(scope){
      var chaps = qa(scope, '.chap:not(.no-arrive)');
      if (!chaps.length) return;
      if (reduce || design || !('IntersectionObserver' in window)) { chaps.forEach(function(c){ c.classList.add('seen', 'in'); }); return; }
      if (!chio) chio = new IntersectionObserver(function(entries){ entries.forEach(function(en){ en.target.classList.toggle('in', en.isIntersecting); if (en.isIntersecting) en.target.classList.add('seen'); }); }, { rootMargin: '-28% 0px -28% 0px', threshold: 0 });
      chaps.forEach(function(c){ chio.observe(c); });
      /* the ones that don't animate in still loop once they're on screen */
    }
    var loopio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){ entries.forEach(function(en){ en.target.classList.toggle('in', en.isIntersecting); }); }, { threshold: 0 }) : null;

    /* ---- trading cards flip; recipe cards open a quick look ---- */
    document.addEventListener('click', function(e){
      var c = e.target.closest('button.tcard'); if (c) { c.setAttribute('aria-pressed', c.getAttribute('aria-pressed') === 'true' ? 'false' : 'true'); return; }
    });
    document.addEventListener('click', function(e){
      var b = e.target.closest('.rcard .plus');
      if (!b) { if (!e.target.closest('.rcard .quick')) qa(document, '.rcard.open').forEach(function(c){ c.classList.remove('open'); c.querySelector('.plus').setAttribute('aria-expanded', 'false'); }); return; }
      var card = b.closest('.rcard'), open = !card.classList.contains('open');
      qa(document, '.rcard.open').forEach(function(c){ c.classList.remove('open'); c.querySelector('.plus').setAttribute('aria-expanded', 'false'); });
      card.classList.toggle('open', open); b.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function(e){
      var cp = e.target.closest('[data-copy]'); if (!cp) return;
      var done = function(){ cp.textContent = cp.getAttribute('data-done') || 'Link copied'; };
      if (cp.hasAttribute('data-share') && navigator.share) { navigator.share({ title: document.title, url: location.href }).catch(function(){}); return; }
      try { navigator.clipboard.writeText(location.href).then(done, done); } catch (err) { done(); }
    });

    /* ---- feedback: buttons lean toward the cursor, homepage cards tilt ---- */
    function pull(scope){
      if (reduce || !M.pull || !matchMedia('(hover:hover) and (pointer:fine)').matches) return;
      qa(scope, '.btn:not([data-pull])').forEach(function(b){
        b.setAttribute('data-pull', '1');
        b.addEventListener('mousemove', function(ev){ var r = b.getBoundingClientRect(); b.style.translate = ((ev.clientX - (r.left + r.width / 2)) * 0.22).toFixed(1) + 'px ' + ((ev.clientY - (r.top + r.height / 2)) * 0.3).toFixed(1) + 'px'; });
        b.addEventListener('mouseleave', function(){ b.style.translate = '0 0'; });
      });
      qa(scope, '.hs .quote:not(.tilt), .hs .card:not(.tilt)').forEach(function(c){
        c.classList.add('tilt');
        c.addEventListener('mousemove', function(ev){ var r = c.getBoundingClientRect(); c.style.setProperty('--ty', (((ev.clientX - r.left) / r.width - 0.5) * 10).toFixed(2) + 'deg'); c.style.setProperty('--tx', (-((ev.clientY - r.top) / r.height - 0.5) * 10).toFixed(2) + 'deg'); c.classList.add('is-hover'); });
        c.addEventListener('mouseleave', function(){ c.classList.remove('is-hover'); });
      });
    }

    /* ---- 18+ check on first visit ---- */
    function ageGate(){
      var g = document.getElementById('agegate'); if (!g || design) return;
      var days = parseInt(g.getAttribute('data-days'), 10) || 30, ok = 0;
      try { ok = parseInt(localStorage.getItem('chelloh-age') || '0', 10); } catch (e) {}
      if (ok && Date.now() - ok < days * 864e5) return;
      g.hidden = false; body.style.overflow = 'hidden';
      var yes = g.querySelector('[data-age="yes"]'); if (yes) yes.focus();
      g.addEventListener('click', function(e){
        var b = e.target.closest('[data-age]'); if (!b) return;
        if (b.getAttribute('data-age') === 'yes') { try { localStorage.setItem('chelloh-age', String(Date.now())); } catch (err) {} g.hidden = true; body.style.overflow = ''; }
        else { var m = g.querySelector('[data-age-msg]'); if (m) m.hidden = false; }
      });
    }

    /* ---- everything that runs per section, so the theme editor can reload one section at a time ---- */
    CH.initScope = function(scope){
      reveals(scope); litSetup(scope); chapters(scope); pull(scope);
      if (loopio) qa(scope, '.chap.no-arrive').forEach(function(c){ loopio.observe(c); });
      if (window.CHBubble) window.CHBubble(scope);
      if (window.CHJuggler) qa(scope, '.juggler').forEach(function(s){ if (!s._chj) { s._chj = 1; if (scope !== document) window.CHJuggler.add(s); } });
    };
    function boot(){
      startLenis();
      CH.initScope(document);
      watchColour(); litUpdate(); ageGate();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

    /* ---- theme editor ---- */
    document.addEventListener('shopify:section:load', function(e){ CH.initScope(e.target); watchColour(); });
    document.addEventListener('shopify:section:unload', function(){ setTimeout(watchColour, 0); });
    document.addEventListener('shopify:section:reorder', function(){ watchColour(); });
    document.addEventListener('shopify:section:select', function(e){ var t = e.target.querySelector('[data-theme]'); if (t) body.setAttribute('data-theme', t.getAttribute('data-theme')); });
    document.addEventListener('shopify:block:select', function(e){
      var c = e.target.closest ? e.target : null; if (!c) return;
      if (c.classList.contains('tcard')) c.setAttribute('aria-pressed', 'false');
      var step = c.closest('.qstep'); if (step) { qa(step.parentNode, '.qstep').forEach(function(s){ s.classList.toggle('on', s === step); }); }
    });
  })();

  /* =================== cart: Shopify's cart, drawn into the drawer and the cart page (.cview), quick add, the Duo upsell =================== */
  (function(){
    var CH = window.CH = window.CH || {};
    var C = CH.cart || {}, S = CH.strings || {}, R = CH.routes || {};
    var root = (R.root || '/').replace(/\/?$/, '/');
    var qa = function(r, s){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    var cart = null, adult = false, busy = false, dobVal = '';
    try { adult = sessionStorage.getItem('chelloh-18') === '1'; dobVal = sessionStorage.getItem('chelloh-dob') || ''; } catch (e) {}
    /* date of birth: 'ok' at 18 or over, 'young' under 18, '' not filled in */
    function dobState(v){
      var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(v || ''); if (!m) return '';
      var d = new Date(+m[1], +m[2] - 1, +m[3]), now = new Date(), a = now.getFullYear() - d.getFullYear();
      if (now.getMonth() < d.getMonth() || (now.getMonth() === d.getMonth() && now.getDate() < d.getDate())) a--;
      return a >= 18 && a < 120 ? 'ok' : (a < 18 ? 'young' : '');
    }

    function money(c, trim){
      var f = (CH.moneyFormat || '${{amount}}').replace(/<[^>]*>/g, ''), m = f.match(/\{\{\s*(\w+)\s*\}\}/), key = m ? m[1] : 'amount';
      function fmt(n, dec, th, ds){ var p = (n / 100).toFixed(dec).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, th); return p[1] ? p[0] + ds + p[1] : p[0]; }
      var v = key === 'amount_no_decimals' ? fmt(c, 0, ',', '.') : key === 'amount_with_comma_separator' ? fmt(c, 2, '.', ',') : key === 'amount_no_decimals_with_comma_separator' ? fmt(c, 0, '.', ',') : key === 'amount_with_apostrophe_separator' ? fmt(c, 2, "'", '.') : fmt(c, 2, ',', '.');
      if (trim) v = v.replace(/[.,]00$/, '');
      return f.replace(/\{\{\s*\w+\s*\}\}/, v);
    }
    CH.money = money;
    function esc(s){ return String(s == null ? '' : s).replace(/[<>&"]/g, function(c){ return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; }); }
    function fill(s, map){ return String(s || '').replace(/\[(\w+)\]/g, function(a, k){ return map[k] != null ? map[k] : a; }); }
    function shortName(t){ return String(t || '').replace(/^CHELL-OH!\s*/i, ''); }
    function api(path, body){
      return fetch(root + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) } : { headers: { 'Accept': 'application/json' } })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); });
    }

    /* colour behind a bottle in the cart: from the product, or cream */
    function bgFor(it){
      var h = (it.handle || '') + ' ' + (it.product_title || '').toLowerCase();
      if (/duo/.test(h)) return 'var(--pink)';
      if (/melon/.test(h)) return 'var(--green)';
      if (/lemon/.test(h)) return 'var(--yellow)';
      return 'var(--cream)';
    }
    function lineHTML(it){
      var img = it.featured_image && it.featured_image.url ? it.featured_image.url : (it.image || '');
      if (img) img = img.replace(/(\.[a-z]+)(\?|$)/i, '$1$2') + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240';
      var pack = it.featured_image && /pack shot|cut-?out|bottle/i.test(it.featured_image.alt || '');
      var sub = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      if (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan) sub = (sub ? sub + ' · ' : '') + it.selling_plan_allocation.selling_plan.name;
      return '<div class="line" data-key="' + esc(it.key) + '"><a class="pic" href="' + esc(it.url) + '" style="background:' + bgFor(it) + '"><span class="img' + (pack ? '' : ' cover') + '" style="background-image:url(\'' + esc(img) + '\')"></span></a>' +
        '<div><b>' + esc(it.product_title) + '</b>' + (sub ? '<span class="sub mono">' + esc(sub) + '</span>' : '') +
        '<div class="lq" role="group" aria-label="Quantity of ' + esc(it.product_title) + '"><button type="button" data-line="' + esc(it.key) + '" data-d="-1" aria-label="Fewer">&minus;</button><output>' + it.quantity + '</output><button type="button" data-line="' + esc(it.key) + '" data-d="1" aria-label="More">+</button></div></div>' +
        '<div class="lr"><span class="mono">' + money(it.final_line_price, true) + '</span><button type="button" class="rm mono" data-rm="' + esc(it.key) + '">' + esc(S.remove || 'Remove') + '</button></div></div>';
    }

    /* the upsell: with one of the pair in the cart, offer the other one (or the bundle, if one is set) */
    function upsell(){
      var U = C.upsell; if (!U || !cart) return null;
      function line(id){ return cart.items.filter(function(i){ return i.variant_id === id; })[0]; }
      if (U.id && line(U.id)) return null;
      var pair = (U.pair || []).map(function(p){ return { p: p, it: line(p.id) }; });
      var have = pair.filter(function(x){ return x.it; }), miss = pair.filter(function(x){ return !x.it; });
      if (!have.length) return null;
      if (!U.id) {
        var o = miss.filter(function(x){ return x.p.ok !== false; })[0]; if (!o) return null;
        var m0 = { other: shortName(o.p.title), price: money(o.p.price, true) };
        var mel = String(o.p.handle || o.p.title || '').toLowerCase().indexOf('melon') > -1, cut = C.cut || {};
        return { t: fill(U.pairHeading, m0), x: fill(U.pairText, m0), b: fill(U.pairButton, m0), n: o.p.title, k: mel ? 'mel' : 'lem', img: (mel ? cut.melon : cut.lemon) || o.p.img, add: o.p.id, drop: [] };
      }
      if (!miss.length) {
        var sum = have.reduce(function(a, x){ return a + x.it.final_price; }, 0), save = Math.max(0, sum - U.price);
        var map = { price: money(U.price, true), saving: money(save, true) };
        return { t: fill(U.swapHeading, map), x: fill(U.swapText, map), b: fill(U.swapButton, map), img: U.img, drop: have.map(function(x){ return x.it; }) };
      }
      var other = miss[0].p, h = have[0];
      var m2 = { other: shortName(other.title), price: money(U.price, true), extra: money(Math.max(0, U.price - h.it.final_price), true) };
      return { t: fill(U.heading, m2), x: fill(U.text, m2), b: fill(U.button, m2), img: other.img || U.img, drop: [h.it] };
    }
    function doUpsell(){
      var up = upsell(); if (!up || busy) return;
      busy = true;
      var updates = {}; up.drop.forEach(function(it){ updates[it.key] = it.quantity - 1; });
      (up.drop.length ? api('cart/update.js', { updates: updates }) : Promise.resolve()).then(function(){ return api('cart/add.js', { items: [{ id: up.add || C.upsell.id, quantity: 1 }] }); })
        .then(refresh).catch(showErr).then(function(){ busy = false; });
    }

    function q(r, n){ return r.querySelector('[data-c="' + n + '"]'); }
    function render(){
      if (!cart) return;
      var n = cart.item_count, tot = cart.total_price, up = upsell(), html = cart.items.map(lineHTML).join('');
      qa(document, '.cview').forEach(function(r){
        var el;
        if ((el = q(r, 'lines'))) el.innerHTML = html;
        if ((el = q(r, 'empty'))) el.hidden = n > 0;
        if ((el = q(r, 'ship'))) {
          el.hidden = n === 0 || !C.free;
          var left = C.free - tot;
          q(r, 'shiptxt').textContent = left <= 0 ? (S.free || 'You’ve got free shipping') : fill(S.away || 'You’re [amount] away from free shipping', { amount: money(left, true) });
          q(r, 'shipbar').style.width = Math.min(100, Math.round(tot / Math.max(1, C.free) * 100)) + '%';
        }
        if ((el = q(r, 'upsell'))) {
          el.hidden = !up;
          if (up) {
            el.className = 'upsell' + (up.k ? ' up-' + up.k : '');
            q(r, 'uptitle').textContent = up.t; q(r, 'upbtn').textContent = up.b;
            var nm = q(r, 'upname'), tx = q(r, 'uptext'), pic = q(r, 'uppic');
            if (nm) { nm.textContent = up.n || ''; nm.hidden = !up.n; }
            if (tx) { tx.textContent = up.x; tx.hidden = !!up.n; }
            if (pic) pic.className = 'up-pic' + (up.k ? ' ' + up.k : ' plain');
            q(r, 'upimg').style.backgroundImage = up.img ? 'url("' + up.img + '")' : '';
          }
        }
        if ((el = q(r, 'gift'))) el.hidden = n === 0;
        if ((el = q(r, 'note')) && document.activeElement !== el) el.value = cart.note || '';
        var foot = r.querySelector('[data-c="foot"]') || (r.parentNode && r.parentNode.querySelector('[data-c="foot"]'));
        if (foot) {
          foot.hidden = n === 0;
          if ((el = foot.querySelector('[data-c="sub"]'))) el.textContent = money(tot, true);
          var age = foot.querySelector('[data-c="age"]'), co = foot.querySelector('[data-c="checkout"]'), dob = foot.querySelector('[data-c="dob"]');
          if (age) age.checked = adult;
          if (dob && dobVal && document.activeElement !== dob) dob.value = dobVal;
          var dobOk = !dob || dobState(dob.value) === 'ok';
          var err = foot.querySelector('[data-c="doberr"]'); if (err) err.hidden = !dob || dobState(dob.value) !== 'young';
          if (co) { co.disabled = (!!age && !adult) || !dobOk; co.textContent = (S.checkout || 'Checkout') + ' · ' + money(tot, true); }
        }
      });
      qa(document, '#cart-count, [data-cart-count]').forEach(function(b){ b.textContent = n; });
    }
    function refresh(){ return api('cart.js').then(function(c){ cart = c; render(); return c; }); }
    function showErr(err){
      var msg = (err && (err.description || err.message)) || S.error || 'Something went wrong. Try again.';
      qa(document, '.cview [data-c="msg"], .cart-foot [data-c="msg"]').forEach(function(m){ m.hidden = false; m.textContent = msg; setTimeout(function(){ m.hidden = true; }, 5000); });
    }

    /* ---- drawer ---- */
    var drawer = document.getElementById('cart'), lastFocus = null;
    function open(){
      if (!drawer) { location.href = R.cart || '/cart'; return; }
      if (window.CHNav) window.CHNav.close();
      lastFocus = document.activeElement; drawer.classList.add('on'); drawer.setAttribute('aria-hidden', 'false');
      var c = document.getElementById('cart-close'); if (c) c.focus();
    }
    function close(){ if (!drawer) return; drawer.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); if (lastFocus && lastFocus.focus) lastFocus.focus(); }
    if (drawer) {
      qa(drawer, '[data-close]').forEach(function(el){ el.addEventListener('click', close); });
      document.addEventListener('keydown', function(e){ if (e.key === 'Escape' && drawer.classList.contains('on')) close(); });
    }
    document.addEventListener('click', function(e){
      var l = e.target.closest('#cart-link, [data-open-cart]'); if (!l) return;
      if (document.body.classList.contains('template-cart')) return;
      e.preventDefault(); open();
    });

    /* ---- adding ---- */
    function added(btn){
      refresh().then(function(){
        if (C.openOnAdd !== false) open();
        else if (btn) { var t = btn.innerHTML; btn.textContent = S.added || 'Added'; setTimeout(function(){ btn.innerHTML = t; }, 1600); }
      });
    }
    function add(items, btn){
      if (btn) btn.setAttribute('aria-busy', 'true');
      return api('cart/add.js', { items: items }).then(function(){ added(btn); }).catch(function(err){ showErr(err); throw err; })
        .then(function(){ if (btn) btn.removeAttribute('aria-busy'); }, function(err){ if (btn) btn.removeAttribute('aria-busy'); throw err; });
    }
    CH.addToCart = add;
    document.addEventListener('click', function(e){
      var b = e.target.closest('[data-add-id]'); if (!b) return;
      e.preventDefault();
      var id = parseInt(b.getAttribute('data-add-id'), 10); if (!id) return;
      add([{ id: id, quantity: parseInt(b.getAttribute('data-qty') || '1', 10) || 1 }], b).catch(function(){});
    });
    /* product forms: stay on the page and open the cart */
    document.addEventListener('submit', function(e){
      var f = e.target.closest('form.pform'); if (!f || !window.fetch) return;
      e.preventDefault();
      var btn = f.querySelector('[type="submit"][name="add"]'), err = f.querySelector('[data-perr]');
      if (err) err.hidden = true;
      if (btn) btn.setAttribute('aria-busy', 'true');
      fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(f) })
        .then(function(r){ return r.json().then(function(j){ if (!r.ok) throw j; return j; }); })
        .then(function(){ added(btn); })
        .catch(function(x){ if (err) { err.hidden = false; err.textContent = (x && x.description) || S.error || 'Something went wrong. Try again.'; } })
        .then(function(){ if (btn) btn.removeAttribute('aria-busy'); });
    });

    /* ---- changing lines, the upsell, the note, 18+ ---- */
    document.addEventListener('click', function(e){
      var b = e.target.closest('.cview button, .cart-foot button'); if (!b || busy) return;
      var line = b.getAttribute('data-line'), rm = b.getAttribute('data-rm');
      if (line || rm) {
        var it = cart && cart.items.filter(function(i){ return i.key === (line || rm); })[0]; if (!it) return;
        var qn = rm ? 0 : Math.max(0, Math.min(99, it.quantity + parseInt(b.getAttribute('data-d'), 10)));
        busy = true;
        api('cart/change.js', { id: it.key, quantity: qn }).then(function(c){ cart = c; render(); }).catch(showErr).then(function(){ busy = false; });
      } else if (b.getAttribute('data-c') === 'upbtn') doUpsell();
    });
    var noteT = null;
    document.addEventListener('input', function(e){
      var t = e.target;
      if (t.matches && t.matches('[data-c="dob"]')) { dobVal = t.value; render(); }
      if (t.matches && t.matches('[data-c="note"]')) { clearTimeout(noteT); var v = t.value; noteT = setTimeout(function(){ api('cart/update.js', { note: v }).then(function(c){ cart = c; }); }, 500); }
    });
    document.addEventListener('change', function(e){
      var t = e.target;
      if (t.matches && t.matches('[data-c="age"]')) { adult = t.checked; try { sessionStorage.setItem('chelloh-18', adult ? '1' : '0'); } catch (err) {} render(); }
      if (t.matches && t.matches('[data-c="dob"]')) { dobVal = t.value; try { sessionStorage.setItem('chelloh-dob', dobVal); } catch (err) {} render(); }
    });
    /* before checkout, make sure the gift note is saved */
    document.addEventListener('submit', function(e){
      var f = e.target.closest('form.cart-foot'); if (!f) return;
      var age = f.querySelector('[data-c="age"]'); if (age && !age.checked) { e.preventDefault(); age.focus(); return; }
      var dob = f.querySelector('[data-c="dob"]'); if (dob && dobState(dob.value) !== 'ok') { e.preventDefault(); dob.focus(); render(); return; }
      var note = document.querySelector('.cview [data-c="note"]');
      if (note && cart && note.value !== (cart.note || '')) { e.preventDefault(); api('cart/update.js', { note: note.value }).then(function(){ var i = document.createElement('input'); i.type = 'hidden'; i.name = 'checkout'; i.value = '1'; f.appendChild(i); f.submit(); }); }
    });

    window.CHCart = { open: open, close: close, refresh: refresh, add: add };
    refresh().catch(function(){});
    /* back/forward cache: the cart may have changed in another tab */
    window.addEventListener('pageshow', function(e){ if (e.persisted) refresh(); });
  })();

  /* =================== homepage-style sections: the travelling logo (Hero card), the product showcase with falling fruit =================== */
  (function(){
    var CH = window.CH = window.CH || {};
    var root = document.documentElement, reduce = CH.reduce, design = CH.design;
    var qa = function(r, s){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    function clamp01(t){ return Math.min(1, Math.max(0, t)); }
    function smooth(t){ return t * t * (3 - 2 * t); }
    function lerp(a, b, t){ return a + (b - a) * t; }
    function mix(a, b, e){ var o = {}; for (var k in a) o[k] = lerp(a[k], b[k], e); return o; }

    /* ---------------- the travelling logo: hero lockup -> nav tab -> footer block ---------------- */
    var H = null;
    function setupMorph(){
      var morph = document.getElementById('morph'), hero = document.getElementById('hero'), nav = document.getElementById('navanchor');
      var flabel = document.getElementById('flabel'), footLt = flabel ? flabel.querySelector('.lt') : null;
      if (!morph || !hero || !nav || !footLt || reduce || design) { root.classList.add('nomorph'); if (hero) hero.style.setProperty('--in', '1'); H = null; return; }
      root.classList.remove('nomorph');
      H = { morph: morph, hero: hero, nav: nav, footLt: footLt, navEl: document.querySelector('header.nav'), l: document.querySelector('.nav-l'), r: document.querySelector('.nav-r'), G: { w0: 300, navTop: 25, x0: 570, k: 0 }, sy: window.scrollY, introT: 1 };
      layoutHero(); updateHero(); placeMorph();
      if (!hero.hasAttribute('data-no-intro') && window.scrollY < 40) {
        H.introT = 0; hero.style.setProperty('--in', '0');
        var t0 = null;
        (function intro(ts){ if (!H) return; if (t0 === null) t0 = ts; var t = Math.min(1, (ts - t0) / 1150); H.introT = t; hero.style.setProperty('--in', (1 - Math.pow(1 - t, 3)).toFixed(4)); placeMorph(); if (t < 1) requestAnimationFrame(intro); else { hero.style.setProperty('--in', '1'); onScroll(); } })(performance.now());
      }
    }
    function layoutHero(){
      if (!H) return;
      var vw = window.innerWidth, mobile = vw <= 820;
      var w0 = mobile ? Math.round(vw * 0.42) : Math.round(Math.min(340, Math.max(220, vw * 0.17)));
      H.G = { w0: w0, navTop: H.nav.getBoundingClientRect().top, x0: (vw - w0) / 2, k: H.G.k };
      H.hero.style.setProperty('--w0', w0 + 'px');
    }
    function updateHero(){
      if (!H) return;
      H.sy += (window.scrollY - H.sy) * 0.22; if (Math.abs(window.scrollY - H.sy) < 0.5) H.sy = window.scrollY;
      H.G.k = clamp01(H.sy / (window.innerHeight * (parseFloat(H.hero.getAttribute('data-scroll')) || 45) / 100));
      H.hero.style.setProperty('--k', smooth(H.G.k).toFixed(4));
    }
    function placeMorph(){
      if (!H) return;
      var na = H.nav.getBoundingClientRect(), fl = H.footLt.getBoundingClientRect(), G = H.G;
      var navP = { x: na.left, y: na.top, w: na.width }, heroP = { x: G.x0, y: G.navTop, w: G.w0 }, footP = { x: fl.left, y: fl.top, w: fl.width };
      var vh = window.innerHeight, P, stretch = 0;
      if (H.introT < 1) {
        var ei = 1 - Math.pow(1 - H.introT, 3); P = mix(navP, heroP, ei); P.y = na.top;
        var st2 = Math.sin(H.introT * Math.PI) * 0.16, s2 = P.w / 640;
        H.morph.style.transform = 'translate(' + P.x.toFixed(1) + 'px,' + P.y.toFixed(1) + 'px) scale(' + s2.toFixed(4) + ',' + (s2 * (1 + st2)).toFixed(4) + ')';
        if (!H.rdy) { H.rdy = 1; root.classList.add('morph-ready'); }
        return;
      }
      var remaining = Math.max(0, root.scrollHeight - vh - window.scrollY), endY = Math.max(na.top, fl.top - remaining);
      var qf = (vh * 0.4 - fl.top) / Math.max(1, vh * 0.4 - endY);
      if (qf > 0) { var q = Math.min(1, qf); P = mix(navP, footP, q); stretch = Math.sin(q * Math.PI) * 0.12; }
      else { P = mix(heroP, navP, smooth(G.k)); P.y = na.top; if (G.k >= 1) P = navP; stretch = Math.sin(G.k * Math.PI) * 0.12; }
      var sc = P.w / 640;
      H.morph.style.transform = 'translate(' + P.x.toFixed(1) + 'px,' + P.y.toFixed(1) + 'px) scale(' + sc.toFixed(4) + ',' + (sc * (1 + stretch)).toFixed(4) + ')';
      if (!H.rdy) { H.rdy = 1; root.classList.add('morph-ready'); }
      var h = P.w * 0.6725 * (1 + stretch);
      function under(box){ if (!box) return false; var r = box.getBoundingClientRect(), cx = (r.left + r.right) / 2, cy = (r.top + r.bottom) / 2; if (cx < P.x || cx > P.x + P.w || cy < P.y) return false; return cy < P.y + h * (1 - 0.4334 * (cx - P.x) / P.w); }
      if (H.navEl) { H.navEl.classList.toggle('blue-l', under(H.l)); H.navEl.classList.toggle('blue-r', under(H.r)); }
      /* keep the logo tab above an open menu once it has docked */
      if (document.body.classList.contains('mega-open')) H.morph.classList.toggle('raise', P.w <= na.width * 1.2);
    }

    /* ---------------- the showcase: one step per product; the page colour, bottle, copy and fruit follow the step in view ---------------- */
    var shows = [];
    function setupShowcases(scope){
      qa(scope, '[data-showcase]').forEach(function(sec){
        if (sec._sc) return;
        var data = []; try { data = JSON.parse(sec.querySelector('script[data-sc-data]').textContent); } catch (e) {}
        var o = { sec: sec, stage: sec.querySelector('.stage'), data: data, tabs: qa(sec, '.tabs button'), steps: qa(sec, '.step'), i: -1,
          price: sec.querySelector('[data-sc-price]'), addBtn: sec.querySelector('[data-sc-add]'), shop: sec.querySelector('[data-sc-shop]'),
          pit: sec.querySelector('.pit:not(.back)'), pitBack: sec.querySelector('.pit.back'), media: sec.querySelector('.media'), physics: sec.getAttribute('data-physics') !== 'false',
          engine: null, runner: null, bodies: [], raf: null, set: -1 };
        sec._sc = o; shows.push(o);
        o.tabs.forEach(function(t){ t.addEventListener('click', function(){ var i = parseInt(t.getAttribute('data-go'), 10); if (o.steps[i]) CH.scrollTo(o.steps[i], 0); }); });
        if (o.addBtn) o.addBtn.addEventListener('click', function(){ var d = o.data[Math.max(0, o.i)]; if (d && d.variant && CH.addToCart) CH.addToCart([{ id: d.variant, quantity: 1 }], o.addBtn).catch(function(){}); });
        if (!reduce && matchMedia('(hover:hover) and (pointer:fine)').matches && o.media) {
          o.stage.addEventListener('mousemove', function(ev){ var r = o.stage.getBoundingClientRect(); o.media.style.setProperty('--mx', ((ev.clientX - r.left) / r.width - 0.5).toFixed(3)); o.media.style.setProperty('--my', ((ev.clientY - r.top) / r.height - 0.5).toFixed(3)); });
          o.stage.addEventListener('mouseleave', function(){ o.media.style.setProperty('--mx', '0'); o.media.style.setProperty('--my', '0'); });
        }
        setActive(o, 0);
      });
    }
    function setActive(o, i){
      if (o.i === i) return;
      o.i = i;
      o.stage.setAttribute('data-active', String(i));
      o.tabs.forEach(function(t, k){ t.classList.toggle('on', k === i); t.setAttribute('aria-selected', String(k === i)); });
      var d = o.data[i] || {};
      if (o.price && d.price) o.price.textContent = d.price;
      if (o.shop && d.url) o.shop.setAttribute('href', d.url);
      startPit(o, i);
    }
    CH.showcaseStep = function(step){ var sec = step.closest('[data-showcase]'); if (sec && sec._sc) setActive(sec._sc, parseInt(step.getAttribute('data-i'), 10) || 0); };

    function startPit(o, i){
      var d = o.data[i];
      if (reduce || design || !o.physics || !window.Matter || !o.pit || !d || !d.fruit || !d.fruit.length) { stopPit(o); return; }
      if (o.engine && o.set === i) return;
      stopPit(o); o.set = i;
      var M = window.Matter, W = o.pit.clientWidth, Hh = o.pit.clientHeight, mobile = W < 700;
      if (!W || !Hh) return;
      var bk = parseFloat(o.sec.getAttribute('data-bscale')) || 1, bottleH = Hh * (mobile ? 0.66 : 0.88) * bk, sc = d.scale || 1;
      var engine = o.engine = M.Engine.create({ gravity: { y: 1.1 } });
      var thick = 200, groundY = Hh - (mobile ? Hh * 0.19 : 28);
      M.Composite.add(engine.world, [
        M.Bodies.rectangle(W / 2, groundY + thick / 2, W * 2, thick, { isStatic: true }),
        M.Bodies.rectangle(-thick / 2, Hh / 2, thick, Hh * 4, { isStatic: true }),
        M.Bodies.rectangle(W + thick / 2, Hh / 2, thick, Hh * 4, { isStatic: true }),
        M.Bodies.rectangle(W / 2, groundY - bottleH * 0.5, bottleH * 0.36, bottleH, { isStatic: true, chamfer: { radius: 40 }, collisionFilter: { category: 0x0002 } })
      ]);
      /* keep the copy clear: on wide screens the paragraph reaches up into the drop zone, so fruit lands on a shelf above it */
      if (!mobile) {
        var pc = o.sec.querySelector('.panel-copy .p' + i) || o.sec.querySelector('.panel-copy > div');
        if (pc) {
          var pr = o.pit.getBoundingClientRect(), cr = pc.getBoundingClientRect(), top = cr.top - pr.top - 34, right = cr.right - pr.left + 24;
          if (top < Hh && right > 0) M.Composite.add(engine.world, M.Bodies.rectangle(right / 2 - thick, top + thick / 2, right + thick * 2, thick, { isStatic: true, chamfer: { radius: 12 } }));
        }
      }
      var picks = (d.picks && (mobile ? d.picks.m : d.picks.d)) || d.fruit.map(function(x, k){ return k; });
      picks.forEach(function(k, n){
        var L = d.fruit[k]; if (!L) return;
        var size = bottleH * L.k * sc, ar = L.ar || 1;
        var w = ar >= 1 ? size : size * ar, h = ar >= 1 ? size / ar : size;
        var r = Math.max(w, h) * (L.shape === 'circle' ? 0.47 : 0.42);
        var x = L.back ? W / 2 + (Math.random() - 0.5) * W * 0.04 : W * (0.1 + Math.random() * 0.8), y = L.back ? -r : -r - n * Hh * 0.35 - Math.random() * Hh * 0.2;
        var phys = { restitution: L.shape ? 0.25 : 0.4, friction: 0.35, frictionAir: 0.008, density: L.shape === 'circle' ? 0.004 : 0.002, collisionFilter: { category: 0x0008, mask: 0x0001 | 0x0002 | 0x0008 } };
        if (L.back) { phys.collisionFilter = { category: 0x0004, mask: 0x0001 }; phys.restitution = 0.18; phys.friction = 0.9; phys.frictionAir = 0.02; }
        var b = L.shape === 'slab' ? M.Bodies.rectangle(x, y, w * 0.92, h * 0.62, Object.assign({ chamfer: { radius: h * 0.2 } }, phys)) : M.Bodies.circle(x, y, r, phys);
        M.Body.setAngularVelocity(b, L.back ? 0 : (Math.random() - 0.5) * 0.25);
        var el = document.createElement('div'); el.className = 'lem';
        el.style.width = w + 'px'; el.style.height = h + 'px'; el.style.backgroundImage = 'url("' + L.img + '")';
        ((L.back && o.pitBack) ? o.pitBack : o.pit).appendChild(el); o.bodies.push({ b: b, el: el, w: w, h: h });
        M.Composite.add(engine.world, b);
      });
      o.runner = M.Runner.create(); M.Runner.run(o.runner, engine);
      (function tick(){ if (!o.engine) return; o.bodies.forEach(function(q){ q.el.style.transform = 'translate(' + (q.b.position.x - q.w / 2) + 'px,' + (q.b.position.y - q.h / 2) + 'px) rotate(' + q.b.angle + 'rad)'; }); o.raf = requestAnimationFrame(tick); })();
    }
    function stopPit(o){
      if (!o.engine) return;
      var M = window.Matter; cancelAnimationFrame(o.raf); M.Runner.stop(o.runner); M.Engine.clear(o.engine);
      o.bodies.forEach(function(q){ q.el.remove(); }); o.bodies = []; o.engine = null; o.runner = null; o.set = -1;
    }
    /* the next section slides the showcase bottles apart as it arrives */
    function handoffs(){
      var vh = window.innerHeight;
      shows.forEach(function(o){ if (!o.sec.isConnected) return; var r = o.sec.getBoundingClientRect(); o.stage.style.setProperty('--split', clamp01(1 - (r.bottom - vh) / (vh * 0.7)).toFixed(3)); });
    }
    /* run the physics only while a showcase is on screen */
    var vio = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){ entries.forEach(function(en){ var o = en.target._sc; if (!o) return; if (en.isIntersecting) { var i = o.i; o.i = -1; setActive(o, Math.max(0, i)); } else stopPit(o); }); }, { threshold: 0 }) : null;

    function onScroll(){ updateHero(); placeMorph(); handoffs(); }
    function onResize(){ layoutHero(); onScroll(); shows.forEach(function(o){ if (o.engine) { var i = o.i; stopPit(o); startPit(o, i); } }); }
    var rt = null;
    window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(onResize, 150); });
    (function tick(){ if (H && (Math.abs(window.scrollY - H.sy) > 0.5)) onScroll(); requestAnimationFrame(tick); })();

    function init(scope){
      setupShowcases(scope);
      if (vio) shows.forEach(function(o){ if (!o._v) { o._v = 1; vio.observe(o.sec); } });
      if (scope === document || scope.querySelector('#hero')) setupMorph();
      onScroll();
    }
    function boot(){
      if (CH.onScroll) CH.onScroll(onScroll);
      init(document);
      setTimeout(function(){ layoutHero(); onScroll(); }, 300); setTimeout(function(){ layoutHero(); onScroll(); }, 1200);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', function(e){ shows = shows.filter(function(o){ if (!o.sec.isConnected) { stopPit(o); return false; } return true; }); init(e.target); });
    document.addEventListener('shopify:block:select', function(e){ var sec = e.target.closest && e.target.closest('[data-showcase]'); if (sec && sec._sc) { var i = parseInt(e.target.getAttribute('data-go'), 10); if (!isNaN(i)) setActive(sec._sc, i); } });
  })();

/* ---------------- homepage hero media: the right video for the screen, the slideshow, and the pause button ---------------- */
(function(){
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mq = window.matchMedia ? window.matchMedia('(max-width: 820px)') : null;
  function shown(el){ return el && window.getComputedStyle(el).display !== 'none'; }
  function setup(scope){
    var card = (scope || document).querySelector('#hero .hcard[data-media]');
    if (!card || card._hm) return;
    card._hm = 1;
    var kind = card.getAttribute('data-media'), btn = card.querySelector('[data-hpause]'), paused = reduce, onScreen = true, api = { play: function(){}, pause: function(){} };
    if (kind === 'video') {
      var vids = Array.prototype.slice.call(card.querySelectorAll('video')), cur = null;
      var pick = function(){
        var want = vids.filter(shown)[0] || vids[0];
        vids.forEach(function(v){ if (v !== want) v.pause(); });
        cur = want;
        if (!cur) return;
        if (cur.preload === 'none') cur.preload = 'auto';
        if (!paused && onScreen) api.play();
      };
      api.play = function(){ if (cur) { var p = cur.play(); if (p && p.catch) p.catch(function(){}); } };
      api.pause = function(){ if (cur) cur.pause(); };
      pick();
      if (mq) { if (mq.addEventListener) mq.addEventListener('change', pick); else if (mq.addListener) mq.addListener(pick); }
    } else if (kind === 'slides') {
      var sl = Array.prototype.slice.call(card.querySelectorAll('.hslide')), dots = Array.prototype.slice.call(card.querySelectorAll('.hdot'));
      var i = 0, t = null, secs = (parseFloat(card.getAttribute('data-secs')) || 5) * 1000;
      var warm = function(){ sl.forEach(function(s){ var d = s.getAttribute('data-bg'), m = s.getAttribute('data-bgm'); if (d) { s.style.setProperty('--s-img', 'url(' + d + ')'); s.removeAttribute('data-bg'); } if (m) { s.style.setProperty('--s-img-m', 'url(' + m + ')'); s.removeAttribute('data-bgm'); } }); };
      if (document.readyState === 'complete') warm(); else window.addEventListener('load', warm);
      var go = function(n){ i = (n + sl.length) % sl.length; sl.forEach(function(s, k){ s.classList.toggle('on', k === i); if (k === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true'); }); dots.forEach(function(d, k){ if (k === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); }); };
      api.play = function(){ clearInterval(t); if (sl.length > 1) t = setInterval(function(){ go(i + 1); }, secs); };
      api.pause = function(){ clearInterval(t); t = null; };
      dots.forEach(function(d, k){ d.addEventListener('click', function(){ warm(); go(k); if (!paused) api.play(); }); });
      card._go = function(n){ warm(); go(n); paused = true; api.pause(); sync(); };
      go(0);
      if (!paused) api.play();
      if (sl.length < 2 && btn) btn.hidden = true;
    }
    function sync(){ if (!btn) return; btn.classList.toggle('is-paused', paused); btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-play' : 'data-pause')); }
    if (btn) btn.addEventListener('click', function(){ paused = !paused; if (paused) api.pause(); else api.play(); sync(); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function(es){ es.forEach(function(e){ onScreen = e.isIntersecting; if (paused) return; if (onScreen) api.play(); else api.pause(); }); }).observe(card);
    sync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ setup(document); }); else setup(document);
  document.addEventListener('shopify:section:load', function(e){ setup(e.target); });
  document.addEventListener('shopify:block:select', function(e){ var c = e.target.closest && e.target.closest('.hcard'); if (c && c._go) { var k = Array.prototype.indexOf.call(c.querySelectorAll('.hslide'), e.target); if (k > -1) c._go(k); } });
})();

  /* =================== product page: gallery, quantity, variants, sticky bar; the quiz =================== */
  (function(){
    var CH = window.CH = window.CH || {};
    var qa = function(r, s){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    function money(c){ return CH.money ? CH.money(c, true) : '$' + (c / 100); }

    function pdp(sec){
      if (sec._pdp) return; sec._pdp = 1;
      var q = function(s){ return sec.querySelector(s); };
      /* gallery */
      var mains = qa(sec, '[data-gal] img'), thumbs = qa(sec, '[data-thumbs] button');
      function show(i){ mains.forEach(function(m, k){ m.classList.toggle('on', k === i); }); thumbs.forEach(function(x, k){ x.classList.toggle('on', k === i); x.setAttribute('aria-selected', String(k === i)); }); }
      thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ show(i); }); });
      /* swipe the main picture on phones */
      var gal = q('[data-gal]'), x0 = null, cur = 0;
      if (gal && mains.length > 1) {
        gal.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
        gal.addEventListener('touchend', function(e){ if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null; if (Math.abs(dx) < 50) return; cur = mains.findIndex(function(m){ return m.classList.contains('on'); }); show((cur + (dx < 0 ? 1 : -1) + mains.length) % mains.length); });
      }
      /* quantity, variant and price */
      var form = q('form.pform'), qty = 1, unit = parseInt(sec.getAttribute('data-price'), 10) || 0;
      var qval = q('[data-qval]'), qin = q('[data-qinput]'), pout = q('[data-pout]'), vsel = q('[data-variant]'), btn = q('[data-addmain]');
      var sticky = form ? document.querySelector('[data-sticky-for="' + form.id + '"]') : null, sprice = sticky ? sticky.querySelector('[data-sprice]') : null;
      function paint(){
        var p = money(unit * qty);
        pout = q('[data-pout]'); if (pout) pout.textContent = p; /* looked up each time: the button's text is swapped back after "Added" */
        var big = q('[data-pout-big]'); if (big) big.textContent = money(unit);
        var meta = q('[data-pout-meta]'); if (meta) meta.textContent = money(unit);
        if (sprice) sprice.textContent = p;
        if (qval) { qval.value = qty; qval.textContent = qty; }
        if (qin) qin.value = qty;
      }
      qa(sec, '.qty [data-q]').forEach(function(b){ b.addEventListener('click', function(){ qty = Math.max(1, Math.min(24, qty + parseInt(b.getAttribute('data-q'), 10))); paint(); }); });
      if (vsel) vsel.addEventListener('change', function(){
        var o = vsel.options[vsel.selectedIndex]; unit = parseInt(o.getAttribute('data-price'), 10) || unit; paint();
        if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', vsel.value); history.replaceState(null, '', u.toString()); }
      });
      /* subscriptions: one-time or a plan; the price follows the choice */
      var plansEl = q('[data-plans]');
      if (plansEl) {
        var pin = plansEl.querySelector('[data-plan-input]');
        var planSync = function(){
          var r = plansEl.querySelector('[data-plan-mode]:checked'); if (!r) return;
          var id = r.value, price = parseInt(r.getAttribute('data-plan-price'), 10);
          var box = r.closest('.plan.sub'), sel = box && box.querySelector('[data-plan-select]');
          if (sel && id) { var o = sel.options[sel.selectedIndex]; id = o.value; price = parseInt(o.getAttribute('data-plan-price'), 10) || price; }
          qa(plansEl, '.plan').forEach(function(p){ p.classList.toggle('on', p.contains(r)); });
          if (pin) pin.value = id || '';
          if (price) unit = price; paint();
        };
        plansEl.addEventListener('change', planSync); planSync();
      }
      /* sticky bar on phones once the buy box has gone by */
      var box = q('.box');
      if (sticky && box && 'IntersectionObserver' in window) new IntersectionObserver(function(en){ sticky.classList.toggle('on', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }, { threshold: 0 }).observe(box);
      if (sticky && form) { var sb = sticky.querySelector('[data-addsticky]'); if (sb) sb.addEventListener('click', function(){ if (form.requestSubmit) form.requestSubmit(btn || undefined); else if (btn) btn.click(); }); }
    }

    /* the quiz: each answer points at a result; most points wins */
    function quiz(sec){
      if (sec._quiz) return; sec._quiz = 1;
      var data = {}; try { data = JSON.parse(sec.querySelector('script[data-quiz-data]').textContent); } catch (e) {}
      var q = function(s){ return sec.querySelector(s); };
      var steps = qa(sec, '.qstep'), prog = qa(sec, '.qprog i'), res = q('.qres'), score = {}, pick = null;
      function show(i){ steps.forEach(function(s, k){ s.classList.toggle('on', k === i); }); prog.forEach(function(p, k){ p.classList.toggle('done', k <= i); }); }
      function reset(){ score = { 1: 0, 2: 0, 3: 0 }; }
      reset();
      steps.forEach(function(s, i){ qa(s, 'button').forEach(function(b){ b.addEventListener('click', function(){
        var v = b.getAttribute('data-v'); score[v] = (score[v] || 0) + 1;
        if (i < steps.length - 1) { show(i + 1); return; }
        var win = Object.keys(score).filter(function(k){ return data[k] && (data[k].title || data[k].name); }).sort(function(a, b2){ return score[b2] - score[a] || a - b2; })[0] || '1';
        var r = data[win] || {}; pick = r;
        q('[data-qtitle]').textContent = r.title || ''; q('[data-qname]').textContent = r.name || ''; q('[data-qblurb]').textContent = r.blurb || '';
        var im = q('[data-qimg]'); if (im) { if (r.img) { im.src = r.img; im.hidden = false; } else im.hidden = true; }
        var add = q('[data-qadd]'); if (add) { add.hidden = !r.variant; if (!add._t) add._t = add.textContent; add.textContent = add._t + (r.price ? ' · ' + r.price : ''); }
        steps.forEach(function(st){ st.classList.remove('on'); }); prog.forEach(function(p){ p.classList.add('done'); }); res.classList.add('on');
      }); }); });
      var again = q('[data-qagain]'); if (again) again.addEventListener('click', function(){ reset(); res.classList.remove('on'); show(0); });
      var addb = q('[data-qadd]'); if (addb) addb.addEventListener('click', function(){ if (pick && pick.variant && CH.addToCart) CH.addToCart([{ id: pick.variant, quantity: 1 }], addb).catch(function(){}); });
    }

    function init(scope){ qa(scope, '[data-pdp]').forEach(pdp); qa(scope, '[data-quiz]').forEach(quiz); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
    document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  })();

  /* =================== stockist finder: search by suburb, postcode or venue; closest first from a known place or your location =================== */
  (function(){
    var CH = window.CH = window.CH || {};
    var qa = function(r, s){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    /* postcodes and suburbs we can place, for "closest first" (Sydney and around; add more as the list grows) */
    var PLACES = {
      '2000': [-33.868, 151.207, 'Sydney'], '2010': [-33.884, 151.213, 'Surry Hills'], '2011': [-33.870, 151.225, 'Potts Point'], '2015': [-33.905, 151.195, 'Alexandria'],
      '2016': [-33.893, 151.204, 'Redfern'], '2017': [-33.900, 151.205, 'Waterloo'], '2021': [-33.884, 151.226, 'Paddington'], '2022': [-33.892, 151.247, 'Bondi Junction'],
      '2024': [-33.900, 151.262, 'Bronte'], '2025': [-33.887, 151.240, 'Woollahra'], '2026': [-33.891, 151.274, 'Bondi'], '2027': [-33.876, 151.244, 'Edgecliff'],
      '2031': [-33.914, 151.241, 'Randwick'], '2034': [-33.920, 151.255, 'Coogee'], '2037': [-33.879, 151.185, 'Glebe'], '2040': [-33.883, 151.157, 'Leichhardt'],
      '2041': [-33.859, 151.179, 'Balmain'], '2042': [-33.898, 151.179, 'Newtown'], '2050': [-33.889, 151.177, 'Camperdown'], '2060': [-33.839, 151.207, 'North Sydney'],
      '2065': [-33.826, 151.200, 'Crows Nest'], '2067': [-33.797, 151.181, 'Chatswood'], '2068': [-33.799, 151.215, 'Castlecrag'], '2088': [-33.829, 151.244, 'Mosman'],
      '2095': [-33.797, 151.285, 'Manly'], '2113': [-33.779, 151.121, 'Macquarie Park'], '2150': [-33.815, 151.003, 'Parramatta'], '2153': [-33.759, 150.993, 'Baulkham Hills'],
      '2154': [-33.731, 151.004, 'Castle Hill'], '2158': [-33.683, 151.028, 'Dural'], '2204': [-33.911, 151.155, 'Marrickville'], '2570': [-34.005, 150.742, 'Oran Park'],
      '2155': [-33.733, 150.988, 'Bella Vista'], '2000b': [-33.866, 151.199, 'Barangaroo'], '2000c': [-33.859, 151.208, 'The Rocks'], '2026b': [-33.889, 151.284, 'North Bondi'],
      '2010b': [-33.879, 151.220, 'Darlinghurst'], '2026c': [-33.891, 151.274, 'Bondi Beach'], '3000': [-37.814, 144.963, 'Melbourne'], '4000': [-27.468, 153.028, 'Brisbane']
    };
    function placeFor(q, venues){
      var k = q.toLowerCase().replace(/\s+(nsw|vic|qld|wa|sa|tas|act|nt)$/, '').trim();
      if (PLACES[k]) return { lat: PLACES[k][0], lng: PLACES[k][1], label: PLACES[k][2] };
      for (var p in PLACES) if (PLACES[p][2].toLowerCase() === k) return { lat: PLACES[p][0], lng: PLACES[p][1], label: PLACES[p][2] };
      /* a suburb one of the stockists is in */
      for (var i = 0; i < venues.length; i++) if (venues[i].lat !== null && String(venues[i].where).toLowerCase() === k) return { lat: venues[i].lat, lng: venues[i].lng, label: venues[i].where };
      return null;
    }
    function km(a, b){ var R = 6371, r = Math.PI / 180, dLa = (b.lat - a.lat) * r, dLo = (b.lng - a.lng) * r; var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2); return 2 * R * Math.asin(Math.sqrt(h)); }
    function esc(s){ return String(s == null ? '' : s).replace(/[<>&"]/g, function(c){ return { '<': '&lt;', '>': '&gt;', '&': '&amp;', '"': '&quot;' }[c]; }); }
    function plain(s){ var d = document.createElement('textarea'); d.innerHTML = s; return d.value; }

    function dirUrl(v){ return 'https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(v.lat !== null ? v.lat + ',' + v.lng : (v.name + ' ' + (v.address || v.where))); }
    function loadLeaflet(map){
      if (CH._LL) return Promise.resolve(CH._LL);
      if (window.L && window.L.map && window.L.divIcon) return Promise.resolve(CH._LL = window.L);
      if (CH._leaflet) return CH._leaflet;
      CH._leaflet = new Promise(function(res, rej){
        var css = document.createElement('link'); css.rel = 'stylesheet'; css.href = map.getAttribute('data-leaflet-css'); document.head.appendChild(css);
        var js = document.createElement('script'); js.src = map.getAttribute('data-leaflet-js'); js.onload = function(){ var LL = window.L; if (!LL || !LL.map) return rej(new Error('leaflet')); CH._LL = LL.noConflict ? LL.noConflict() : LL; res(CH._LL); }; js.onerror = rej; document.head.appendChild(js);
      });
      return CH._leaflet;
    }

    function finder(sec){
      var root = sec.querySelector('[data-finder]'); if (!root || root._f) return; root._f = 1;
      var venues = []; try { venues = JSON.parse(sec.querySelector('script[data-venues]').textContent).filter(Boolean); } catch (e) {}
      venues = venues.map(function(v, i){ v.i = i; v.name = plain(v.name); v.where = plain(v.where); v.address = plain(v.address || ''); if (typeof v.lat !== 'number' || isNaN(v.lat)) v.lat = null; if (typeof v.lng !== 'number' || isNaN(v.lng)) v.lng = null; return v; });
      var short = root.getAttribute('data-finder') === 'short', many = parseInt(root.getAttribute('data-show'), 10) || 4;
      var out = root.querySelector('[data-fres]'), form = root.querySelector('[data-fform]'), mapEl = root.querySelector('[data-fmap]');
      var words = { venue: root.getAttribute('data-venue-word') || 'Bar or restaurant', retail: root.getAttribute('data-retail-word') || 'Retail' };
      var dirWord = (mapEl && mapEl.getAttribute('data-dir')) || 'Directions', siteWord = (mapEl && mapEl.getAttribute('data-site')) || 'Website';
      var gated = !short && root.getAttribute('data-list') === 'search';
      var st = { w: 'all', q: '', from: null, note: '', on: !gated, pick: null };
      var M = null; /* the live map, once it has loaded */

      function links(v){
        var a = [];
        if (!short && v.lat !== null) a.push('<a href="' + esc(dirUrl(v)) + '" target="_blank" rel="noopener">' + esc(dirWord) + '</a>');
        if (v.url) a.push('<a href="' + esc(v.url) + '" target="_blank" rel="noopener">' + esc(siteWord) + '</a>');
        return a.join('');
      }
      function item(x){
        var v = x.v, sub = (v.where ? esc(v.where) + (v.lat !== null && v.state ? ' ' + esc(v.state) : '') + ' &middot; ' : '') + esc(words[v.w] || '');
        var km = x.d !== null && x.d !== undefined && isFinite(x.d) ? (x.d < 1 ? 'Under 1 km' : x.d.toFixed(1) + ' km') : '';
        if (short) {
          var tag = v.url ? 'a' : 'div';
          return '<' + tag + ' class="fitem"' + (v.url ? ' href="' + esc(v.url) + '" target="_blank" rel="noopener"' : '') + '><div><b>' + esc(v.name) + '</b><span class="where mono">' + sub + '</span></div><span class="km">' + km + '</span></' + tag + '>';
        }
        var l = links(v);
        return '<div class="fitem' + (st.pick === v.i ? ' on' : '') + '" data-vi="' + v.i + '"><div>' +
          (M && v.lat !== null ? '<button type="button" class="fname" data-pin="' + v.i + '"><b>' + esc(v.name) + '</b></button>' : '<b>' + esc(v.name) + '</b>') +
          '<span class="where mono">' + sub + '</span>' + (v.address ? '<span class="addr">' + esc(v.address) + '</span>' : '') +
          (l ? '<span class="flinks mono">' + l + '</span>' : '') + '</div><span class="km">' + km + '</span></div>';
      }
      function draw(){
        var list = venues.filter(function(v){ return st.w === 'all' || v.w === st.w; }), head;
        if (M) M.show(list);
        if (!st.on) {
          var online = list.filter(function(v){ return v.lat === null; });
          out.innerHTML = (st.note ? '<p class="fnote mono">' + st.note + '</p>' : '') + '<div class="fprompt"><p>' + esc(root.getAttribute('data-prompt') || '') + '</p><button type="button" class="more mono" data-all>' + esc(root.getAttribute('data-all') || 'See the full list') + ' (' + list.length + ')</button></div>' +
            (online.length ? '<div class="fonline"><span class="mono">' + esc(root.getAttribute('data-online') || 'Online') + '</span>' + online.map(function(v){ return item({ v: v, d: null }); }).join('') + '</div>' : '');
          return;
        }
        if (st.pick !== null && !st.q && !st.from) {
          var pv = venues[st.pick];
          out.innerHTML = '<div class="fhead mono"><span>' + esc(pv.where || words[pv.w]) + '</span><button type="button" class="more mono" data-all>' + esc(root.getAttribute('data-all') || 'See the full list') + ' (' + list.length + ')</button></div>' +
            venues.filter(function(v){ return v.lat !== null && pv.lat !== null && km(v, pv) < 0.06; }).map(function(v){ return item({ v: v, d: null }); }).join('');
          return;
        }
        if (st.from) {
          list = list.map(function(v){ return { v: v, d: v.lat === null ? Infinity : km(st.from, v) }; }).sort(function(a, b){ return a.d - b.d || a.v.i - b.v.i; });
          head = ['Closest to ' + esc(st.from.label), list.length + ' places'];
        } else if (st.q) {
          var qq = st.q.toLowerCase().replace(/’/g, "'");
          list = list.filter(function(v){ return (v.name + ' ' + v.where + ' ' + (v.state || '') + ' ' + (v.address || '')).toLowerCase().replace(/’/g, "'").indexOf(qq) > -1; }).map(function(v){ return { v: v, d: null }; });
          head = [list.length + ' matching &ldquo;' + esc(st.q) + '&rdquo;', ''];
        } else {
          list = list.map(function(v){ return { v: v, d: null }; });
          head = [list.length + ' places', esc(root.getAttribute('data-region') || '')];
        }
        var shown = short ? list.slice(0, many) : list;
        if (M && !short) M.fit(st.from ? shown.slice(0, 6).map(function(x){ return x.v; }).concat([st.from]) : shown.map(function(x){ return x.v; }));
        out.innerHTML = '<div class="fhead mono"><span>' + head[0] + '</span><span>' + head[1] + '</span></div>' + (st.note ? '<p class="fnote mono">' + st.note + '</p>' : '') +
          (shown.length ? shown.map(item).join('') : '<p class="none">' + esc(root.getAttribute('data-none') || 'Nothing matching that yet.') + '</p>');
      }
      function search(q){
        q = (q || '').trim(); st.note = ''; st.pick = null; st.on = true;
        var p = q ? placeFor(q, venues) : null;
        if (p) { st.from = p; st.q = ''; } else { st.from = null; st.q = q; }
        draw();
      }

      /* ---- the live map ---- */
      function mapInit(){
        if (!mapEl || short) return;
        var go = function(){
          loadLeaflet(mapEl).then(function(L){
            var canvas = mapEl.querySelector('[data-fmap-canvas]');
            var map = L.map(canvas, { scrollWheelZoom: false, dragging: !L.Browser.mobile, tap: false, zoomControl: true, attributionControl: true });
            map.attributionControl.setPrefix(false);
            L.tileLayer(mapEl.getAttribute('data-tiles') || 'https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: mapEl.getAttribute('data-attr') || '© OpenStreetMap contributors' }).addTo(map);
            map.on('click focus', function(){ map.scrollWheelZoom.enable(); });
            canvas.addEventListener('mouseleave', function(){ map.scrollWheelZoom.disable(); });
            /* one pin per address: places within 60 m share a pin */
            var groups = [];
            venues.forEach(function(v){
              if (v.lat === null) return;
              var g = groups.filter(function(g){ return km(g.at, v) < 0.06; })[0];
              if (g) g.vs.push(v); else groups.push({ at: { lat: v.lat, lng: v.lng }, vs: [v] });
            });
            groups.forEach(function(g){
              var kinds = g.vs.map(function(v){ return v.w; }), mixed = kinds.indexOf('venue') > -1 && kinds.indexOf('retail') > -1;
              g.icon = function(n, k){ return L.divIcon({ className: 'fpin-wrap', html: '<span class="fpin w-' + k + '">' + (n > 1 ? '<em>' + n + '</em>' : '') + '</span>', iconSize: [30, 38], iconAnchor: [15, 36], popupAnchor: [0, -32] }); };
              g.m = L.marker([g.at.lat, g.at.lng], { icon: g.icon(g.vs.length, mixed ? 'mixed' : kinds[0]), keyboard: true, title: g.vs.map(function(v){ return v.name; }).join(', '), riseOnHover: true });
              g.m.bindPopup(function(){ return '<div class="fpop">' + g.shown.map(function(v){ var l = links(v); return '<div><b>' + esc(v.name) + '</b><span class="mono">' + esc(words[v.w] || '') + '</span>' + (v.address ? '<span>' + esc(v.address) + '</span>' : '') + (l ? '<span class="flinks mono">' + l + '</span>' : '') + '</div>'; }).join('') + '</div>'; }, { maxWidth: 280, minWidth: 210 });
              g.m.on('click', function(){ st.pick = g.shown[0].i; st.on = true; st.q = ''; st.from = null; if (form) form.elements.q.value = ''; draw(); });
            });
            var layer = L.featureGroup().addTo(map);
            M = {
              show: function(list){
                var ids = {}; list.forEach(function(v){ ids[v.i] = 1; });
                groups.forEach(function(g){
                  g.shown = g.vs.filter(function(v){ return ids[v.i]; });
                  if (!g.shown.length) { layer.removeLayer(g.m); return; }
                  var kinds = g.shown.map(function(v){ return v.w; }), mixed = kinds.indexOf('venue') > -1 && kinds.indexOf('retail') > -1;
                  g.m.setIcon(g.icon(g.shown.length, mixed ? 'mixed' : kinds[0]));
                  if (!layer.hasLayer(g.m)) layer.addLayer(g.m);
                });
              },
              fit: function(pts){
                map.closePopup();
                pts = pts.filter(function(p){ return p && p.lat !== null && p.lat !== undefined; });
                if (!pts.length) return;
                /* the first fit happens before the map has a view: jump there, don't fly */
                var ready = !!map._loaded;
                if (pts.length === 1) { if (ready) map.flyTo([pts[0].lat, pts[0].lng], 15, { duration: .6 }); else map.setView([pts[0].lat, pts[0].lng], 15); return; }
                var bounds = L.latLngBounds(pts.map(function(p){ return [p.lat, p.lng]; }));
                if (ready) map.flyToBounds(bounds, { padding: [40, 40], maxZoom: 15, duration: .6 }); else map.fitBounds(bounds, { padding: [40, 40], maxZoom: 15 });
              },
              open: function(i){ var g = groups.filter(function(g){ return g.vs.some(function(v){ return v.i === i; }); })[0]; if (!g) return; map.flyTo([g.at.lat, g.at.lng], Math.max(map.getZoom(), 15), { duration: .6 }); setTimeout(function(){ g.m.openPopup(); }, 650); },
              all: function(){ if (layer.getLayers().length) map.fitBounds(layer.getBounds(), { padding: [30, 30], maxZoom: 14 }); }
            };
            draw(); if (!map._loaded) M.all(); if (!map._loaded) map.setView([-33.87, 151.21], 11);
            mapEl.classList.add('ready');
            if (window.ResizeObserver) new ResizeObserver(function(){ map.invalidateSize(); }).observe(canvas);
          }).catch(function(e){ mapEl.classList.add("failed"); if (window.console) console.warn("map", e); });
        };
        if ('IntersectionObserver' in window) { var io = new IntersectionObserver(function(en){ if (en[0].isIntersecting) { io.disconnect(); go(); } }, { rootMargin: '300px' }); io.observe(mapEl); } else go();
      }

      if (form) {
        form.addEventListener('submit', function(e){ e.preventDefault(); search(form.elements.q.value); });
        form.addEventListener('click', function(e){
          var b = e.target.closest('button[data-w]'); if (b) { st.w = b.getAttribute('data-w'); st.on = true; st.pick = null; qa(b.parentNode, 'button').forEach(function(x){ x.classList.toggle('on', x === b); }); draw(); return; }
          if (e.target.closest('[data-geo]')) {
            form.elements.q.value = ''; st.on = true; st.pick = null;
            if (!navigator.geolocation) { st.note = 'Location isn&rsquo;t available here. Try a suburb or postcode.'; draw(); return; }
            st.note = 'Finding you&hellip;'; draw();
            navigator.geolocation.getCurrentPosition(function(pos){ st.note = ''; st.q = ''; st.from = { lat: pos.coords.latitude, lng: pos.coords.longitude, label: 'you' }; draw(); },
              function(){ st.note = 'Location is switched off. Try a suburb or postcode.'; draw(); }, { timeout: 8000, maximumAge: 600000 });
          }
        });
      }
      out.addEventListener('click', function(e){
        if (e.target.closest('[data-all]')) { st.on = true; st.pick = null; st.q = ''; st.from = null; if (form) form.elements.q.value = ''; draw(); if (M) M.all(); return; }
        var pin = e.target.closest('[data-pin]'); if (pin && M) { var i = parseInt(pin.getAttribute('data-pin'), 10); qa(out, '.fitem').forEach(function(x){ x.classList.toggle('on', x.getAttribute('data-vi') === String(i)); }); M.open(i); if (window.innerWidth < 821) mapEl.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      });
      /* /pages/stockists?q=bondi searches straight away */
      var pre = new URLSearchParams(location.search).get('q');
      if (pre && !short && form) { form.elements.q.value = pre; search(pre); } else draw();
      mapInit();
    }
    function init(scope){ qa(scope, '[data-finder]').forEach(function(f){ var sec = f.closest('section') || f.parentNode; finder(sec); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function(){ init(document); }); else init(document);
    document.addEventListener('shopify:section:load', function(e){ init(e.target); });
  })();

  /* =================== round 3: header hide/show, fitted words, hover words, before/after slider, recipe cards, sign-up pop-up, card nudge =================== */
  (function(){
    var CH = window.CH = window.CH || {};
    var qa = function(r, s){ return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var design = !!(window.Shopify && window.Shopify.designMode);
    var esc = function(s){ return String(s == null ? '' : s).replace(/[<>&]/g, function(c){ return { '<': '&lt;', '>': '&gt;', '&': '&amp;' }[c]; }); };

    /* ---- header: the links slide away on the way down, come back with a solid band on the way up; the logo stays ---- */
    function headerScroll(){
      var nav = document.querySelector('header.nav'); if (!nav || nav._hs) return; nav._hs = 1;
      var last = window.scrollY;
      function update(){
        var y = window.scrollY, open = document.body.classList.contains('mega-open') || nav.classList.contains('mega-on');
        if (y < 90 || open) { nav.classList.remove('nav-hide'); if (y < 90) nav.classList.remove('nav-solid'); last = y; return; }
        if (y > last + 6) { nav.classList.add('nav-hide'); nav.classList.remove('nav-solid'); last = y; }
        else if (y < last - 6) { nav.classList.remove('nav-hide'); nav.classList.add('nav-solid'); last = y; }
      }
      if (CH.onScroll) CH.onScroll(update); else window.addEventListener('scroll', update, { passive: true });
      update();
    }

    /* ---- words that stretch to fill their box (the MISSING on the poster) ---- */
    function fit(el){
      var t = el.firstElementChild; if (!t) return;
      el.style.fontSize = ''; var w = el.clientWidth, tw = t.getBoundingClientRect().width; if (!w || !tw) return;
      var fs = parseFloat(getComputedStyle(el).fontSize);
      el.style.fontSize = (fs * w / tw * 0.995).toFixed(2) + 'px';
    }
    function fitAll(scope){ qa(scope || document, '[data-fit]').forEach(fit); }

    /* ---- big paragraphs: words react when you hover them ---- */
    function hoverWords(scope){
      qa(scope, '[data-hover-fx]').forEach(function(p){
        if (p.querySelector('.w')) return;
        if (p.hasAttribute('data-lit-lines') && !reduce && !design) return; /* the lit script splits it */
        p.innerHTML = p.textContent.trim().split(/[ \t\n\r]+/).map(function(w){ return '<span class="w">' + esc(w) + '</span>'; }).join(' ');
      });
    }

    /* ---- before / after slider ---- */
    function sliders(scope){
      qa(scope, '[data-compare]').forEach(function(c){
        if (c._cmp) return; c._cmp = 1;
        var h = c.querySelector('[data-handle]'), dragging = false;
        function set(x){ var r = c.getBoundingClientRect(); var p = Math.max(0, Math.min(100, (x - r.left) / r.width * 100)); c.style.setProperty('--pos', p.toFixed(2) + '%'); if (h) h.setAttribute('aria-valuenow', Math.round(p)); }
        c.addEventListener('pointerdown', function(e){ dragging = true; c.setPointerCapture(e.pointerId); set(e.clientX); c.classList.add('dragging'); });
        c.addEventListener('pointermove', function(e){ if (dragging) set(e.clientX); });
        ['pointerup', 'pointercancel'].forEach(function(ev){ c.addEventListener(ev, function(){ dragging = false; c.classList.remove('dragging'); }); });
        if (h) h.addEventListener('keydown', function(e){
          var v = parseFloat(getComputedStyle(c).getPropertyValue('--pos')) || 50;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowRight') { e.preventDefault(); v = Math.max(0, Math.min(100, v + (e.key === 'ArrowLeft' ? -5 : 5))); c.style.setProperty('--pos', v + '%'); h.setAttribute('aria-valuenow', Math.round(v)); }
        });
        /* a little nudge when it first comes on screen, so people know it moves */
        if (!reduce && !design && 'IntersectionObserver' in window && c.hasAttribute('data-nudge')) {
          var io = new IntersectionObserver(function(en){ if (!en[0].isIntersecting) return; io.disconnect(); c.classList.add('nudge'); setTimeout(function(){ c.classList.remove('nudge'); }, 2200); }, { threshold: 0.5 });
          io.observe(c);
        }
      });
    }

    /* ---- recipe card: draws a card for the recipe and saves it as a picture ---- */
    function wrap(ctx, text, maxW){
      var words = String(text).split(/[ \t\n\r]+/), lines = [], line = '';
      words.forEach(function(w){ var t = line ? line + ' ' + w : w; if (ctx.measureText(t).width > maxW && line) { lines.push(line); line = w; } else line = t; });
      if (line) lines.push(line); return lines;
    }
    function loadImg(src){ return new Promise(function(res){ if (!src) return res(null); var i = new Image(); i.crossOrigin = 'anonymous'; i.onload = function(){ res(i); }; i.onerror = function(){ res(null); }; i.src = src; }); }
    function recipeCard(btn){
      var d = {}; try { d = JSON.parse(btn.parentNode.querySelector('script[data-card-data]').textContent); } catch (e) { return; }
      var ta = document.createElement('textarea'), dec = function(v){ if (typeof v !== 'string') return v; ta.innerHTML = v; return ta.value.replace(/\s+/g, ' ').trim(); };
      ['title', 'line', 'glass', 'serves', 'bottleName', 'kicker'].forEach(function(k){ d[k] = dec(d[k]); });
      d.ingredients = (d.ingredients || []).map(dec).filter(Boolean); d.method = (d.method || []).map(dec).filter(Boolean);
      var cs = getComputedStyle(document.body), bg = (cs.getPropertyValue('--bg') || '#FFE100').trim(), fg = (cs.getPropertyValue('--fg') || '#0048C1').trim();
      if (d.bg) bg = cs.getPropertyValue('--' + d.bg).trim() || bg;
      if (d.fg) fg = cs.getPropertyValue('--' + d.fg).trim() || fg;
      var label = btn.textContent; btn.textContent = btn.getAttribute('data-busy') || 'Making your card…'; btn.disabled = true;
      var fonts = document.fonts ? Promise.all(['700 80px Apercu', '400 30px Apercu', '600 24px "Source Code Pro"'].map(function(f){ return document.fonts.load(f).catch(function(){}); })) : Promise.resolve();
      Promise.all([fonts, loadImg(d.bottle), loadImg(d.logo)]).then(function(r){
        var bottle = r[1], logo = r[2], W = 1080, H = 1350, P = 72;
        var cv = document.createElement('canvas'); cv.width = W; cv.height = H; var x = cv.getContext('2d');
        x.fillStyle = bg; x.fillRect(0, 0, W, H);
        /* bottle leaning in from the bottom right */
        if (bottle) { var bh = 720, bw = bh * bottle.width / bottle.height; x.save(); x.translate(W - bw * 0.62, H - 118); x.rotate(-0.07); x.globalAlpha = 0.95; x.drawImage(bottle, -bw / 2, -bh, bw, bh); x.restore(); }
        x.fillStyle = fg; x.textBaseline = 'alphabetic';
        x.font = '600 24px "Source Code Pro", monospace'; var mono = function(t, xx, yy){ x.save(); x.font = '600 24px "Source Code Pro", monospace'; if (x.letterSpacing !== undefined) x.letterSpacing = '3px'; x.fillText(String(t).toUpperCase(), xx, yy); x.restore(); };
        mono(d.kicker || 'CHELL-OH! recipe', P, P + 20);
        var logoBottom = P;
        if (logo) { var lw = 190, lh = lw * logo.height / logo.width; x.drawImage(logo, W - P - lw, P - 12, lw, lh); logoBottom = P - 12 + lh; }
        /* title: as big as fits */
        var title = String(d.title || '').toUpperCase(), fs = 150; x.font = '700 ' + fs + 'px Apercu, Helvetica, sans-serif';
        var tl = wrap(x, title, W - P * 2);
        while ((tl.length > 2 || tl.some(function(l){ return x.measureText(l).width > W - P * 2; })) && fs > 64) { fs -= 6; x.font = '700 ' + fs + 'px Apercu, Helvetica, sans-serif'; tl = wrap(x, title, W - P * 2); }
        var y = Math.max(P + 70, logoBottom + 36) + fs * 0.78;
        tl.forEach(function(l){ x.fillText(l, P - 4, y); y += fs * 0.88; });
        y += 6;
        if (d.line) { x.font = '400 32px Apercu, Helvetica, sans-serif'; wrap(x, d.line, W - P * 2).slice(0, 2).forEach(function(l){ x.fillText(l, P, y + 8); y += 42; }); y += 12; }
        var parts = [d.glass ? 'Glass: ' + d.glass : '', d.serves ? 'Serves ' + d.serves : '', d.bottleName || ''].filter(Boolean), rows = [], cur = '';
        x.save(); x.font = '600 24px "Source Code Pro", monospace'; if (x.letterSpacing !== undefined) x.letterSpacing = '3px';
        parts.forEach(function(pt){ var t = cur ? cur + '   ·   ' + pt : pt; if (cur && x.measureText(t.toUpperCase()).width > W - P * 2) { rows.push(cur); cur = pt; } else cur = t; }); if (cur) rows.push(cur); x.restore();
        rows.forEach(function(r){ mono(r, P, y + 16); y += 40; }); if (rows.length) y += 18;
        var colW = W - P * 2 - (bottle ? 330 : 0);
        if (d.ingredients && d.ingredients.length) {
          mono('Ingredients', P, y + 10); y += 52; x.font = '400 31px Apercu, Helvetica, sans-serif';
          d.ingredients.forEach(function(g){ wrap(x, g, colW - 34).forEach(function(l, k){ if (!k) x.fillText('•', P, y); x.fillText(l, P + 30, y); y += 40; }); });
          y += 20;
        }
        if (d.method && d.method.length) {
          mono('Method', P, y + 10); y += 52; x.font = '400 30px Apercu, Helvetica, sans-serif';
          d.method.forEach(function(m, n){ var ls = wrap(x, m, colW - 40); ls.forEach(function(l, k){ if (y > H - 170) return; if (!k && d.method.length > 1) x.fillText(String(n + 1) + '.', P, y); x.fillText(l, P + (d.method.length > 1 ? 40 : 0), y); y += 40; }); y += 10; });
        }
        mono((d.site || location.host) + '   ·   Drink responsibly. 18+', P, H - P + 6);
        cv.toBlob(function(b){
          btn.textContent = label; btn.disabled = false; if (!b) return;
          var a = document.createElement('a'); a.href = URL.createObjectURL(b); a.download = (d.file || 'chelloh-recipe') + '.png';
          document.body.appendChild(a); a.click(); setTimeout(function(){ URL.revokeObjectURL(a.href); a.remove(); }, 1500);
        }, 'image/png');
      });
    }
    document.addEventListener('click', function(e){ var b = e.target.closest('[data-card-dl]'); if (b) { e.preventDefault(); recipeCard(b); } });

    /* ---- the floating sign-up: a pill that opens the offer; hidden for a while once someone signs up or closes it ---- */
    function signupFloat(){
      var root = document.getElementById('sfloat'); if (!root || root._sf) return; root._sf = 1;
      var days = parseInt(root.getAttribute('data-days'), 10) || 14, key = 'chelloh-sfloat', t = 0;
      try { t = parseInt(localStorage.getItem(key) || '0', 10); } catch (e) {}
      var done = !!root.querySelector('[data-sf-success]'), dlg = root.querySelector('[data-sf-panel]'), pill = root.querySelector('[data-sf-open]');
      function remember(){ try { localStorage.setItem(key, String(Date.now())); } catch (e) {} }
      function open(){ root.classList.add('open'); dlg.hidden = false; var f = dlg.querySelector('input:not([type=hidden])'); if (f) setTimeout(function(){ f.focus(); }, 50); }
      function close(){ root.classList.remove('open'); dlg.hidden = true; }
      if (done) { root.hidden = false; open(); remember(); }
      else if (!design && t && Date.now() - t < days * 864e5) { root.hidden = true; return; }
      else {
        /* wait for the age check, then show the pill after a moment */
        var show = function(){ var g = document.getElementById('agegate'); if (g && !g.hidden) { setTimeout(show, 1200); return; } root.hidden = false; requestAnimationFrame(function(){ root.classList.add('in'); }); };
        setTimeout(show, design ? 0 : 2500);
      }
      if (pill) pill.addEventListener('click', open);
      qa(root, '[data-sf-close]').forEach(function(b){ b.addEventListener('click', function(){ close(); if (b.hasAttribute('data-sf-dismiss')) { remember(); root.classList.remove('in'); setTimeout(function(){ root.hidden = true; }, 400); } }); });
      root.addEventListener('keydown', function(e){ if (e.key === 'Escape') close(); });
      var copy = root.querySelector('[data-sf-copy]');
      if (copy) copy.addEventListener('click', function(){ var c = copy.getAttribute('data-code'); try { navigator.clipboard.writeText(c).then(function(){ copy.textContent = copy.getAttribute('data-done') || 'Copied'; }); } catch (e) {} });
    }

    /* ---- trading cards: a little flip wiggle until someone has flipped one ---- */
    document.addEventListener('click', function(e){ var c = e.target.closest('button.tcard'); if (c) { var w = c.closest('.tcards'); if (w) w.classList.add('touched'); } });

    /* ---- story cards: a fanned deck; the front card flies off and tucks in at the back ---- */
    function decks(scope){
      qa(scope, '[data-deck]').forEach(function(root){
        if (root._dk) return; root._dk = 1;
        var cards = qa(root, '[data-deck-card]'), n = cards.length, at = 0, busy = false, timer = null, now = root.querySelector('[data-deck-now]');
        if (n < 2) return;
        var pad = function(v){ return (v < 9 ? '0' : '') + (v + 1); };
        function lay(){
          cards.forEach(function(c, i){
            var p = (i - at + n) % n;
            c.style.setProperty('--p', p); c.style.zIndex = String(n - p);
            c.classList.toggle('front', p === 0); c.classList.toggle('far', p > 3); c.setAttribute('aria-hidden', p === 0 ? 'false' : 'true');
            qa(c, 'a,button').forEach(function(el){ if (p === 0) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1'); });
          });
          if (now) now.textContent = pad(at);
        }
        function go(dir){
          if (busy) return; busy = true;
          var wait = reduce ? 0 : 380;
          if (dir > 0) {
            var out = cards[at]; out.classList.add('fling');
            setTimeout(function(){ at = (at + 1) % n; out.classList.remove('fling'); lay(); busy = false; }, wait);
          } else {
            var back = cards[(at - 1 + n) % n]; back.classList.add('fling', 'from-back'); void back.offsetWidth; back.classList.remove('far');
            setTimeout(function(){ at = (at - 1 + n) % n; lay(); requestAnimationFrame(function(){ back.classList.remove('fling', 'from-back'); }); busy = false; }, reduce ? 0 : 40);
          }
        }
        function stop(){ if (timer) { clearInterval(timer); timer = null; } }
        var nx = root.querySelector('[data-deck-next]'), pv = root.querySelector('[data-deck-prev]');
        if (nx) nx.addEventListener('click', function(){ stop(); go(1); });
        if (pv) pv.addEventListener('click', function(){ stop(); go(-1); });
        root.addEventListener('keydown', function(e){ if (e.key === 'ArrowRight') { stop(); go(1); } else if (e.key === 'ArrowLeft') { stop(); go(-1); } });
        /* swipe or drag the front card */
        var stage = root.querySelector('[data-deck-stage]'), sx = null, sy = 0;
        stage.addEventListener('pointerdown', function(e){ if (e.target.closest('a,button')) return; sx = e.clientX; sy = e.clientY; });
        stage.addEventListener('pointerup', function(e){ if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { stop(); go(dx < 0 ? 1 : -1); } else if (Math.abs(dx) < 6 && Math.abs(dy) < 6 && !e.target.closest('.front')) { stop(); go(1); } });
        stage.addEventListener('pointercancel', function(){ sx = null; });
        var auto = parseInt(root.getAttribute('data-auto'), 10);
        if (auto > 0 && !reduce && !design) timer = setInterval(function(){ if (document.visibilityState === 'visible') go(1); }, auto * 1000);
        lay();
        /* the editor: selecting a card brings it to the front */
        cards.forEach(function(c, i){ c.addEventListener('shopify:block:select', function(){ at = i; lay(); }); });
      });
    }

    function init(scope){ fitAll(scope); hoverWords(scope); sliders(scope); decks(scope); }
    function boot(){ headerScroll(); init(document); signupFloat(); if (document.fonts && document.fonts.ready) document.fonts.ready.then(function(){ fitAll(document); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    var rt = null; window.addEventListener('resize', function(){ clearTimeout(rt); rt = setTimeout(function(){ fitAll(document); }, 120); });
    document.addEventListener('shopify:section:load', function(e){ init(e.target); if (e.target.querySelector('#sfloat')) signupFloat(); });
  })();

/* ---------------- ticker: "Changes colour as you scroll past" runs the band through the brand pairs ---------------- */
(function(){
  var PAIRS = [['blue','cream'],['pink','purple'],['green','purple'],['orange','blue'],['purple','cream'],['yellow','blue']];
  var bands = [], raf = 0;
  function tick(){
    raf = 0;
    var vh = window.innerHeight, page = document.body.getAttribute('data-theme');
    var list = PAIRS.filter(function(p){ return p[0] !== page; });
    bands.forEach(function(b){
      var box = b.closest('.tick-angle') || b, r = box.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var prog = Math.max(0, Math.min(0.999, (vh - r.top) / (vh + r.height)));
      var pr = list[Math.floor(prog * list.length)];
      if (b._cyc !== pr[0]) { b._cyc = pr[0]; b.style.background = 'var(--' + pr[0] + ')'; b.style.color = 'var(--' + pr[1] + ')'; }
    });
  }
  function on(){ if (!raf) raf = requestAnimationFrame(tick); }
  function collect(){ bands = Array.prototype.slice.call(document.querySelectorAll('[data-cycle]')); bands.forEach(function(b){ b._cyc = null; }); tick(); }
  window.addEventListener('scroll', on, { passive: true });
  window.addEventListener('resize', on);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', collect); else collect();
  document.addEventListener('shopify:section:load', collect);
})();
